{
  "absences.actions.add": "+ Abwesenheit",
  "absences.delete.confirm": "Diese Abwesenheit wirklich löschen?",
  "absences.empty": "In dieser Organisation gibt es keine aktuellen Dienstverhältnisse.",
  "absences.errors.loadFailed": "Der Abwesenheitskalender konnte nicht geladen werden.",
  "absences.form.add": "Hinzufügen",
  "absences.form.choosePerson": "Person wählen …",
  "absences.form.close": "Schließen",
  "absences.form.createTitle": "Neue Abwesenheit",
  "absences.form.editTitle": "Abwesenheit bearbeiten",
  "absences.form.fields.dateFrom": "Von",
  "absences.form.fields.dateTo": "Bis",
  "absences.form.fields.note": "Notiz",
  "absences.form.fields.person": "Person",
  "absences.form.fields.type": "Art",
  "absences.form.generated": "Diese Abwesenheit hat das Regelwerk aus der Stempelung geschrieben. Sie lässt sich hier nicht ändern — der nächste Lauf würde die Änderung wieder überschreiben.",
  "absences.form.problems.isGenerated": "Diese Abwesenheit hat das Regelwerk geschrieben und lässt sich nicht von Hand ändern.",
  "absences.form.problems.overlaps": "Diese Person hat in diesem Zeitraum bereits eine Abwesenheit.",
  "absences.form.problems.overlapsGenerated": "An diesen Tagen steht bereits eine Abwesenheit, die das Regelwerk aus der Stempelung geschrieben hat.",
  "absences.form.problems.saveFailed": "Die Abwesenheit konnte nicht gespeichert werden.",
  "absences.form.saving": "Speichert …",
  "absences.form.validation.dateFromRequired": "Bitte den ersten Tag angeben.",
  "absences.form.validation.dateToRequired": "Bitte den letzten Tag angeben.",
  "absences.form.validation.noteMaxLength": "Die Notiz darf höchstens 500 Zeichen lang sein.",
  "absences.form.validation.personRequired": "Bitte eine Person wählen.",
  "absences.form.validation.rangeReversed": "„Bis“ darf nicht vor „Von“ liegen.",
  "absences.form.viewTitle": "Abwesenheit",
  "absences.generated": "vom Regelwerk aus der Stempelung geschrieben",
  "absences.hint": "Klick auf einen Tag in einer Zeile trägt dort eine Abwesenheit ein, Klick auf einen Balken öffnet ihn. Strg + Mausrad zoomt.",
  "access.permission.group.skill": "Fähigkeiten",
  "access.permission.skill.admin": "Fähigkeiten verwalten",
  "access.permission.skill.admin.description": "Den Katalog der Fähigkeiten anlegen, ändern und löschen.",
  "auth.callback.backToSignIn": "Zurück zur Anmeldung",
  "auth.callback.errors.authFailed": "Authentifizierung fehlgeschlagen. Bitte erneut versuchen.",
  "auth.callback.errors.exchangeFailed": "Austausch fehlgeschlagen ({{status}}).",
  "auth.callback.errors.missingCode": "Autorisierungscode fehlt.",
  "auth.callback.errors.serverNotConfirmed": "Server hat Authentifizierung nicht bestätigt.",
  "auth.callback.errors.sessionAfterSignIn": "Sitzung nach Anmeldung konnte nicht hergestellt werden.",
  "auth.callback.errors.sessionFailed": "Sitzung konnte nicht hergestellt werden. Bitte erneut anmelden.",
  "auth.callback.exchanging": "Autorisierungscode wird ausgetauscht…",
  "auth.callback.subtitle": "Bitte warten Sie, während wir Ihr Konto verbinden.",
  "auth.callback.success": "Erfolgreich. Weiterleitung…",
  "auth.callback.title": "Anmeldung wird abgeschlossen",
  "auth.forgotPassword.errors.invalidToken": "Dieser Link zum Zurücksetzen ist ungültig oder abgelaufen.",
  "auth.forgotPassword.errors.passwordRequirements": "Das Passwort erfüllt nicht die Anforderungen.",
  "auth.forgotPassword.errors.requestFailed": "Der Link zum Zurücksetzen konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
  "auth.forgotPassword.errors.resetFailed": "Das Passwort konnte nicht zurückgesetzt werden. Bitte versuchen Sie es erneut.",
  "auth.forgotPassword.request.form.emailLabel": "E-Mail-Adresse",
  "auth.forgotPassword.request.form.emailPlaceholder": "E-Mail-Adresse eingeben",
  "auth.forgotPassword.request.sending": "Link zum Zurücksetzen wird gesendet …",
  "auth.forgotPassword.request.signInPrompt": "Passwort wieder eingefallen?",
  "auth.forgotPassword.request.submit": "Link zum Zurücksetzen senden",
  "auth.forgotPassword.request.subtitle": "Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen zu erhalten.",
  "auth.forgotPassword.request.title": "Passwort zurücksetzen",
  "auth.forgotPassword.reset.form.confirmPasswordLabel": "Passwort bestätigen",
  "auth.forgotPassword.reset.form.confirmPasswordPlaceholder": "Neues Passwort bestätigen",
  "auth.forgotPassword.reset.form.emailLabel": "E-Mail-Adresse",
  "auth.forgotPassword.reset.form.newPasswordLabel": "Neues Passwort",
  "auth.forgotPassword.reset.form.newPasswordPlaceholder": "Neues Passwort eingeben",
  "auth.forgotPassword.reset.signInPrompt": "Zurück zur Anmeldung?",
  "auth.forgotPassword.reset.submit": "Passwort aktualisieren",
  "auth.forgotPassword.reset.submitting": "Passwort wird aktualisiert …",
  "auth.forgotPassword.reset.subtitle": "Geben Sie Ihr neues Passwort ein, um die Zurücksetzung abzuschließen.",
  "auth.forgotPassword.reset.title": "Neues Passwort festlegen",
  "auth.forgotPassword.signInLink": "Hier anmelden",
  "auth.forgotPassword.success.emailSent": "Wenn ein Konto mit dieser E-Mail-Adresse existiert, wurde ein Link zum Zurücksetzen gesendet.",
  "auth.forgotPassword.success.passwordUpdated": "Das Passwort wurde erfolgreich aktualisiert. Sie können sich jetzt anmelden.",
  "auth.forgotPassword.validation.confirmPasswordRequired": "Bitte bestätigen Sie Ihr Passwort",
  "auth.forgotPassword.validation.passwordMinLength": "Das Passwort muss mindestens 8 Zeichen haben",
  "auth.forgotPassword.validation.passwordMismatch": "Die Passwörter stimmen nicht überein",
  "auth.forgotPassword.validation.passwordRequired": "Passwort ist erforderlich",
  "auth.login.credentials.invalid": "E-Mail oder Passwort ungültig. Bitte versuchen Sie es erneut.",
  "auth.login.credentials.unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  "auth.login.error.title": "Anmeldefehler",
  "auth.login.errors.Callback": "Beim Rückruf ist ein Problem aufgetreten.",
  "auth.login.errors.CredentialsSignin": "Anmeldung fehlgeschlagen. Bitte prüfen Sie Ihre Angaben.",
  "auth.login.errors.default": "Während der Anmeldung ist ein Fehler aufgetreten.",
  "auth.login.errors.EmailCreateAccount": "Konto konnte nicht erstellt werden.",
  "auth.login.errors.emailNotVerified": "Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse, bevor Sie sich anmelden. Prüfen Sie Ihren Posteingang auf den Bestätigungslink.",
  "auth.login.errors.EmailSignin": "Prüfen Sie Ihre E-Mail auf den Anmeldelink.",
  "auth.login.errors.invite_required": "Für die Registrierung ist eine Einladung erforderlich. Bitten Sie eine Administratorin oder einen Administrator Ihrer Organisation um einen Einladungslink.",
  "auth.login.errors.inviteRequired": "Für die Registrierung ist eine Einladung erforderlich. Bitten Sie eine Administratorin oder einen Administrator Ihrer Organisation um einen Einladungslink.",
  "auth.login.errors.OAuthAccountNotLinked": "Konto nicht verknüpft. Bitte melden Sie sich mit demselben Konto an wie zuvor.",
  "auth.login.errors.OAuthCallback": "Beim OAuth-Rückruf ist ein Problem aufgetreten.",
  "auth.login.errors.OAuthCreateAccount": "Konto konnte nicht erstellt werden.",
  "auth.login.errors.OAuthSignin": "Bei der OAuth-Anmeldung ist ein Problem aufgetreten.",
  "auth.login.errors.pending_approval": "Ihr Konto wurde erstellt, ist aber noch nicht aktiv. Ein Administrator muss Ihren Zugang freigeben, bevor Sie sich anmelden können.",
  "auth.login.errors.pendingApproval": "Ihr Konto wurde erstellt, ist aber noch nicht aktiv. Ein Administrator muss Ihren Zugang freigeben, bevor Sie sich anmelden können.",
  "auth.login.errors.Signin": "Bei der Anmeldung ist ein Problem aufgetreten.",
  "auth.login.forgotPassword": "Passwort vergessen?",
  "auth.login.form.emailLabel": "E-Mail-Adresse",
  "auth.login.form.emailPlaceholder": "E-Mail-Adresse eingeben",
  "auth.login.form.passwordLabel": "Passwort",
  "auth.login.form.passwordPlaceholder": "Passwort eingeben",
  "auth.login.noMethodsConfigured": "Für diese Anwendung sind keine Anmeldemethoden konfiguriert. Bitte wenden Sie sich an Ihre Administratorin oder Ihren Administrator, damit mindestens eine Methode aktiviert wird (E-Mail/Passwort, Microsoft oder Discord).",
  "auth.login.oauth.continueWith": "Oder weiter mit",
  "auth.login.oauth.custom": "Anmelden",
  "auth.login.oauth.discord": "Discord",
  "auth.login.oauth.google": "Google",
  "auth.login.oauth.microsoft": "Microsoft",
  "auth.login.pageSubtitle": "Melden Sie sich mit E-Mail oder einem verbundenen Konto an.",
  "auth.login.pageTitle": "Anmelden",
  "auth.login.pendingApproval.title": "Konto wartet auf Freigabe",
  "auth.login.rateLimit.message": "Bitte warten Sie {{seconds}} Sekunden, bevor Sie es erneut versuchen.",
  "auth.login.rateLimit.title": "Zu viele Versuche",
  "auth.login.rememberMe": "Angemeldet bleiben",
  "auth.login.signIn": "Anmelden",
  "auth.login.signingIn": "Anmeldung läuft …",
  "auth.login.signUp.link": "Hier registrieren",
  "auth.login.signUp.prompt": "Noch kein Konto?",
  "auth.login.validation.passwordMinLength": "Das Passwort muss mindestens 6 Zeichen haben",
  "auth.login.validation.passwordRequired": "Passwort ist erforderlich",
  "auth.logout": "Abmelden",
  "auth.password.errors.notAvailable": "Passwortänderung ist nicht verfügbar.",
  "auth.register.createAccount": "Konto erstellen",
  "auth.register.creatingAccount": "Konto wird erstellt …",
  "auth.register.errors.emailAlreadyExists": "Ein Konto mit dieser E-Mail existiert bereits.",
  "auth.register.errors.failedGeneric": "Registrierung fehlgeschlagen.",
  "auth.register.errors.failedRetry": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "auth.register.errors.fillRequired": "Bitte füllen Sie alle Pflichtfelder aus.",
  "auth.register.errors.inviteRequired": "Für die Registrierung ist eine Einladung erforderlich. Bitten Sie eine Administratorin oder einen Administrator Ihrer Organisation um einen Einladungslink.",
  "auth.register.errors.notAvailable": "Registrierung ist nicht verfügbar.",
  "auth.register.form.emailLabel": "E-Mail-Adresse",
  "auth.register.form.emailPlaceholder": "E-Mail-Adresse eingeben",
  "auth.register.form.nameLabel": "Vollständiger Name",
  "auth.register.form.namePlaceholder": "Geben Sie Ihren vollständigen Namen ein",
  "auth.register.form.passwordLabel": "Passwort",
  "auth.register.form.passwordPlaceholder": "Erstellen Sie ein sicheres Passwort",
  "auth.register.passwordHint": "Mindestens 8 Zeichen mit Groß- und Kleinbuchstaben, Zahl und Sonderzeichen",
  "auth.register.passwordUnavailable.lead": "Registrierung mit E-Mail und Passwort ist nicht verfügbar. Nutzen Sie eine andere Anmeldemethode oder",
  "auth.register.passwordUnavailable.signInLink": "zur Anmeldung zurück",
  "auth.register.signIn.link": "Hier anmelden",
  "auth.register.signIn.prompt": "Haben Sie bereits ein Konto?",
  "auth.register.subtitle": "Werden Sie Teil unserer Community und legen Sie los",
  "auth.register.title": "Konto erstellen",
  "auth.register.validation.nameMaxLength": "Der Name darf höchstens 255 Zeichen haben",
  "auth.register.validation.nameRequired": "Der vollständige Name ist erforderlich",
  "auth.register.validation.passwordMaxLength": "Das Passwort darf höchstens 128 Zeichen haben",
  "auth.register.validation.passwordMinLength": "Das Passwort muss mindestens 8 Zeichen haben",
  "auth.register.validation.passwordPattern": "Das Passwort muss Groß- und Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten",
  "auth.register.validation.passwordRequired": "Passwort ist erforderlich",
  "auth.resendVerification.failed": "Es konnte keine neue Bestätigungs-E-Mail gesendet werden. Bitte versuchen Sie es erneut.",
  "auth.verifyEmail.failed": "Ihre E-Mail-Adresse konnte nicht bestätigt werden. Der Link ist möglicherweise abgelaufen.",
  "common.actions.cancel": "Abbrechen",
  "common.actions.delete": "Löschen",
  "common.actions.edit": "Bearbeiten",
  "common.actions.reset": "Zurücksetzen",
  "common.actions.save": "Speichern",
  "common.form.optional": "optional",
  "common.form.validation.companyMaxLength": "Unternehmen darf höchstens 255 Zeichen lang sein",
  "common.form.validation.emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  "common.form.validation.emailMaxLength": "E-Mail darf höchstens 255 Zeichen lang sein",
  "common.form.validation.emailRequired": "E-Mail ist erforderlich",
  "common.form.validation.firstNameMaxLength100": "Vorname darf höchstens 100 Zeichen lang sein",
  "common.form.validation.firstNameRequired": "Vorname ist erforderlich",
  "common.form.validation.lastNameMaxLength100": "Nachname darf höchstens 100 Zeichen lang sein",
  "common.form.validation.lastNameRequired": "Nachname ist erforderlich",
  "common.form.validation.maxLength1000": "Darf höchstens 1000 Zeichen lang sein",
  "common.form.validation.nameMaxLength": "Name ist zu lang",
  "common.form.validation.nameRequired": "Name ist erforderlich",
  "common.form.validation.phoneMaxLength": "Telefonnummer darf höchstens 30 Zeichen lang sein",
  "common.form.validation.titleMaxLength10": "Titel darf höchstens 10 Zeichen lang sein",
  "common.form.validation.typeRequired": "Typ ist erforderlich",
  "common.loading": "Loading…",
  "common.messages.confirm": "Sind Sie sicher?",
  "common.messages.deleteConfirm": "Möchten Sie dieses Element wirklich löschen?",
  "common.messages.error": "Ein Fehler ist aufgetreten",
  "common.messages.success": "Vorgang erfolgreich abgeschlossen",
  "contacts.actions.create": "Kontakt hinzufügen",
  "contacts.delete.description": "Diese Aktion kann nicht rückgängig gemacht werden.",
  "contacts.details.contactInfo": "Kontaktinformationen",
  "contacts.details.fields.company": "Unternehmen",
  "contacts.details.fields.createdAt": "Erstellt am",
  "contacts.details.fields.updatedAt": "Aktualisiert am",
  "contacts.details.professionalInfo": "Berufliche Informationen",
  "contacts.details.tags": "Tags",
  "contacts.errors.personAlreadyExists": "Ein Kontakt mit dieser E-Mail existiert bereits.",
  "contacts.form.createTitle": "Kontakt hinzufügen",
  "contacts.form.editTitle": "Kontakt bearbeiten",
  "contacts.form.fields.additionalEmail": "Zusätzliche E-Mail",
  "contacts.form.fields.email": "E-Mail",
  "contacts.form.fields.firstName": "Vorname",
  "contacts.form.fields.lastName": "Nachname",
  "contacts.form.fields.phone": "Telefon",
  "contacts.form.fields.tags": "Tags",
  "contacts.form.fields.title": "Titel",
  "contacts.form.fields.type": "Typ",
  "contacts.form.help.tags": "Wählen Sie ein oder mehrere Tags zur Klassifizierung dieses Kontakts aus.",
  "contacts.form.placeholders.additionalEmail": "Zusätzliche E-Mail eingeben (optional)",
  "contacts.form.placeholders.email": "E-Mail-Adresse eingeben",
  "contacts.form.placeholders.firstName": "Vorname eingeben",
  "contacts.form.placeholders.lastName": "Nachname eingeben",
  "contacts.form.placeholders.phone": "Telefonnummer eingeben",
  "contacts.form.placeholders.title": "Titel auswählen",
  "contacts.form.sections.contact": "Kontaktdaten",
  "contacts.form.sections.name": "Name",
  "contacts.tags.host": "Gastgeber",
  "contacts.types.contractor": "Auftragnehmer",
  "contacts.types.employee": "Mitarbeiter",
  "contacts.types.guest": "Gast",
  "contacts.types.resident": "Bewohner",
  "contacts.types.visitor": "Besucher",
  "costCenter.actions.create": "Kostenstelle anlegen",
  "costCenter.actions.hide": "Hier ausblenden",
  "costCenter.actions.override": "Hier überschreiben",
  "costCenter.actions.restore": "Lokale Fassung entfernen (erbt wieder)",
  "costCenter.delete.confirm": "Möchten Sie diese Kostenstelle wirklich löschen?",
  "costCenter.errors.loadFailed": "Kostenstellen konnten nicht geladen werden.",
  "costCenter.form.createTitle": "Neue Kostenstelle",
  "costCenter.form.editTitle": "Kostenstelle bearbeiten",
  "costCenter.form.fields.department": "Bereich (optional)",
  "costCenter.form.fields.isInactive": "Zur Zeit ungültig",
  "costCenter.form.fields.name": "Bezeichnung",
  "costCenter.form.fields.number": "Kostenstellennummer",
  "costCenter.form.fields.validFrom": "Gültig ab",
  "costCenter.form.fields.validTo": "Gültig bis",
  "costCenter.form.overrideTitle": "Kostenstelle überschreiben",
  "costCenter.form.saving": "Speichern …",
  "costCenter.form.validation.departmentMaxLength": "Bereich ist zu lang.",
  "costCenter.form.validation.nameMaxLength": "Bezeichnung ist zu lang.",
  "costCenter.form.validation.nameRequired": "Bezeichnung ist erforderlich.",
  "costCenter.form.validation.numberMaxLength": "Kostenstellennummer ist zu lang.",
  "costCenter.form.validation.numberRequired": "Kostenstellennummer ist erforderlich.",
  "costCenter.form.validation.validFromRequired": "Gültig ab ist erforderlich.",
  "costCenter.list.empty": "Noch keine Kostenstellen vorhanden.",
  "costCenter.list.inactive": "ungültig",
  "costCenter.list.inheritedFrom": "geerbt von {{unit}}",
  "costCenter.list.overridden": "überschrieben",
  "dashboard.noPerson.description": "Ihr Konto ist noch keiner Person in einer Organisation zugeordnet, daher gibt es hier nichts anzuzeigen. Bitten Sie eine Administratorin oder einen Administrator um einen Einladungslink.",
  "dashboard.noPerson.title": "Keine Organisation zugeordnet",
  "dashboard.persons.grid.description": "Personen in der ausgewählten Organisation anzeigen und verwalten.",
  "dashboard.scaffold.dummyDescription": "Platzhalterseite",
  "dashboard.scaffold.gridPlaceholder": "ag-grid Platzhalter",
  "dashboard.time.accounts.balanceDummy": "Dummy-Daten für Monats-Saldo",
  "dashboard.time.accounts.chartPlaceholder": "ag-chart Platzhalter — {{count}} Datenpunkte",
  "dashboard.time.accounts.chartPlaceholderSimple": "ag-chart Platzhalter",
  "dashboard.time.accounts.historyTitle": "Zeitkonto Verlauf",
  "dashboard.time.accounts.hoursDummy": "Dummy-Daten für geleistete Stunden",
  "dashboard.time.accounts.rangeLabel": "Zeitraum",
  "dsl.editor.activate": "Aktivieren",
  "dsl.editor.activating": "Wird aktiviert…",
  "dsl.editor.active": "Aktiv",
  "dsl.editor.compileError.MULTIPLE_PIPELINES": "Es gibt mehr als einen rule-configuration-Block. Genau einen behalten und alle Regeln dort hineinlegen.",
  "dsl.editor.compileError.PIPELINE_MISSING": "Es gibt keinen rule-configuration-Block, dadurch kann nichts ausgeführt werden. Einen aus der Kategorie Structure hinzufügen.",
  "dsl.editor.compileError.title": "Gespeichert, aber keine ausführbaren Regeln",
  "dsl.editor.context.appliesTo": "Gilt für die Zeitmodelle:",
  "dsl.editor.context.appliesToAll": "Gilt für alle Zeitmodelle dieser Einheit.",
  "dsl.editor.context.appliesToAllHint": "Stufe 1 nennt kein Zeitmodell. Ein Regelwerk derselben Einheit, das eines ausdrücklich nennt, gewinnt für dieses Zeitmodell.",
  "dsl.editor.context.governsNobody": "Dieses Regelwerk gilt für niemanden.",
  "dsl.editor.context.governsNobodyHint": "Stufe 1 ist leer, also folgt diesem Regelwerk kein Vertrag. Block „applies to time model\" einsetzen und speichern — er gilt zunächst für alle Zeitmodelle.",
  "dsl.editor.context.shadows": "Ersetzt das gleichnamige Regelwerk von {{unit}}.",
  "dsl.editor.draft": "Entwurf — läuft noch nicht",
  "dsl.editor.draftRunning": "Entwurf — Version {{running}} läuft",
  "dsl.editor.loadFailed": "Das Regelwerk konnte nicht geladen werden.",
  "dsl.editor.noVersionYet": "Noch nicht gespeichert",
  "dsl.editor.referenceIssues": "Dieses Regelwerk verweist auf Stammdaten, die es in dieser Organisationseinheit nicht mehr gibt:",
  "dsl.editor.masterDataIssues": "Diese Version liest Stammdaten, die so nicht gelesen werden können. Aktivieren ist erst nach der Korrektur möglich:",
  "dsl.editor.masterDataIssue.UNKNOWN_ENTITY": "unbekannter Bezug",
  "dsl.editor.masterDataIssue.UNKNOWN_FIELD": "unbekanntes Feld",
  "dsl.editor.masterDataIssue.UNKNOWN_DAY": "unbekannter Tag",
  "dsl.editor.masterDataIssue.FIELD_OF_OTHER_ENTITY": "das Feld gehört nicht zu diesem Bezug",
  "dsl.editor.masterDataIssue.NO_PREVIOUS_DAY": "für dieses Feld gibt es keinen Vortag",
  "dsl.editor.masterDataIssue.CHANGED_ON_LOAD": "gespeichert, aber beim Laden verändert – bitte Block prüfen und erneut speichern",
  "dsl.editor.referenceKind.account": "Konto",
  "dsl.editor.referenceKind.bookingType": "Buchungsart",
  "dsl.editor.referenceKind.timeType": "Zeitart",
  "dsl.editor.save": "Regelwerk speichern",
  "dsl.editor.saveConflict.allTimeModels": "Das Regelwerk „{{ruleSet}}“ ({{ruleSetCode}}) dieser Organisationseinheit gilt bereits für alle Zeitmodelle. Nur ein Regelwerk je Einheit kann das — nennen Sie hier ein bestimmtes Zeitmodell und speichern Sie erneut.",
  "dsl.editor.saveConflict.timeModel": "Das Zeitmodell {{workSchedule}} ist bereits dem Regelwerk „{{ruleSet}}“ ({{ruleSetCode}}) dieser Organisationseinheit zugeordnet. Ein Zeitmodell kann nur einem Regelwerk je Einheit gehören — entfernen Sie es hier oder dort aus der Zuordnung und speichern Sie erneut.",
  "dsl.editor.saveConflict.title": "Nicht gespeichert",
  "dsl.editor.saving": "Speichern …",
  "dsl.editor.title": "Regelwerk",
  "dsl.editor.version": "Version {{version}}",
  "dsl.masterData.fields.entryDate": "Eintritt",
  "dsl.masterData.fields.exitDate": "Austritt",
  "dsl.masterData.fields.sicknessReferenceDate": "Krank-Stichtag",
  "dsl.masterData.fields.sicknessServiceDurationDays": "Krank: anspruchsrelevante Dienstdauer (Tage)",
  "dsl.masterData.fields.sicknessServiceStartDate": "Krank: Beginn der anrechenbaren Dienstzeit",
  "dsl.masterData.fields.vacationReferenceDate": "Urlaubsstichtag",
  "dsl.masterData.fields.vacationServiceDurationDays": "Urlaub: anspruchsrelevante Dienstdauer (Tage)",
  "dsl.masterData.fields.vacationServiceStartDate": "Urlaub: Beginn der anrechenbaren Dienstzeit",
  "dsl.masterData.fields.vacationWaitingPeriodMonths": "Wartezeit bis zum ersten Urlaubsanspruch (Monate)",
  "dsl.masterData.fields.vacationYearType": "Urlaubsjahr",
  "dsl.masterData.fields.weeklyTargetMinutes": "Wochen-Sollzeit aus dem Zeitmodell (Minuten)",
  "dsl.masterData.fields.workDaysPerWeek": "Arbeitstage pro Woche",
  "dsl.ruleSets.actions.create": "Regelwerk anlegen",
  "dsl.ruleSets.create.title": "Neues Regelwerk",
  "dsl.ruleSets.delete.confirm": "Dieses Regelwerk mitsamt allen Versionen löschen?",
  "dsl.ruleSets.empty": "Diese Einheit hat kein eigenes Regelwerk. Es gilt das der nächsten übergeordneten Einheit.",
  "dsl.ruleSets.fields.code": "Code",
  "dsl.ruleSets.fields.codeHint": "Der Schlüssel, auf den die Vererbung trifft. Großbuchstaben, keine Leerzeichen — später nicht mehr änderbar.",
  "dsl.ruleSets.fields.name": "Bezeichnung",
  "dsl.ruleSets.loadFailed": "Die Regelwerke konnten nicht geladen werden.",
  "dsl.ruleSets.neverSaved": "noch nicht gespeichert",
  "dsl.ruleSets.problems.codePattern": "Der Code darf nur A–Z, 0–9 und Unterstriche enthalten.",
  "dsl.ruleSets.problems.codeRequired": "Bitte einen Code eingeben.",
  "dsl.ruleSets.problems.codeTaken": "Diese Einheit hat bereits ein Regelwerk mit diesem Code.",
  "dsl.ruleSets.problems.nameRequired": "Bitte eine Bezeichnung eingeben.",
  "dsl.ruleSets.validation.codePattern": "Der Code darf nur A–Z, 0–9 und Unterstriche enthalten.",
  "dsl.status.edit": "Regelwerk bearbeiten",
  "dsl.status.lastChanged": "Zuletzt geändert",
  "dsl.status.loadFailed": "Der Status des Regelwerks konnte nicht geladen werden.",
  "dsl.status.noRuleSet": "Für diese Organisationseinheit ist noch kein Regelwerk definiert.",
  "dsl.status.version": "Version {{version}}",
  "employment.entity.absence": "Abwesenheit",
  "employment.entity.group.time": "Zeit",
  "employments.create": "Neues Dienstverhältnis",
  "employments.empty": "Für diese Einheit gibt es noch keine Dienstverhältnisse.",
  "employments.errors.loadFailed": "Die Dienstverhältnisse konnten nicht geladen werden.",
  "employments.fields.employmentNumber": "Nummer",
  "employments.fields.employmentRelationship": "Dienstnehmergruppe",
  "employments.fields.employmentType": "Vertragsart",
  "employments.fields.entryDate": "Eintritt",
  "employments.fields.exitDate": "Austritt",
  "employments.fields.payGrade": "Gehaltsgruppe",
  "employments.fields.payGradeLevel": "KV-Stufe",
  "employments.fields.payScale": "Kollektivvertrag",
  "employments.fields.person": "Person",
  "employments.fields.sicknessCreditedFrom": "Krank: anrechenbar ab",
  "employments.fields.sicknessCreditedMonths": "Krank: anrechenbare Monate",
  "employments.fields.sicknessReferenceDate": "Krank-Stichtag",
  "employments.fields.vacationCreditedFrom": "Urlaub: anrechenbar ab",
  "employments.fields.vacationCreditedMonths": "Urlaub: anrechenbare Monate",
  "employments.fields.vacationReferenceDate": "Urlaubsstichtag",
  "employments.fields.validFrom": "Gültig ab",
  "employments.fields.validTo": "Gültig bis",
  "employments.fields.weeklyHours": "Wochenstunden",
  "employments.fields.workSchedule": "Zeitmodell",
  "employments.form.choose": "Bitte wählen…",
  "employments.form.choosePerson": "Bitte Person wählen…",
  "employments.form.chooseWorkSchedule": "Bitte Zeitmodell wählen…",
  "employments.form.createTitle": "Neues Dienstverhältnis",
  "employments.form.creditedHint": "Vordienstzeiten je Zweck entweder als Datum oder als Monate angeben, nicht beides. Leer heißt: nichts angerechnet.",
  "employments.form.editTitle": "Dienstverhältnis bearbeiten",
  "employments.form.none": "— keine —",
  "employments.form.noWorkSchedules": "Für diese Organisationseinheit gibt es noch keine Zeitmodelle. Bitte unter Zeitwirtschaft → Zeitmodelle eines anlegen.",
  "employments.form.personFixed": "Person und Organisationseinheit lassen sich bei einem bestehenden Dienstverhältnis nicht ändern.",
  "employments.form.problems.employmentNumber": "Bitte eine Dienstverhältnisnummer eingeben.",
  "employments.form.problems.employmentType": "Bitte eine Vertragsart wählen.",
  "employments.form.problems.entryDate": "Bitte ein Eintrittsdatum eingeben.",
  "employments.form.problems.exitDateBeforeEntry": "Das Austrittsdatum liegt vor dem Eintritt.",
  "employments.form.problems.notAnEmployer": "Dienstverhältnisse gehören zu einer Firma. Diese Organisationseinheit ist keine — bitte über die Liste eine Firma wählen.",
  "employments.form.problems.organizationUnitId": "Es wurde keine Organisationseinheit übergeben. Bitte über die Liste beginnen.",
  "employments.form.problems.personId": "Bitte eine Person wählen.",
  "employments.form.problems.saveFailed": "Speichern fehlgeschlagen. Bitte erneut versuchen.",
  "employments.form.problems.validFrom": "Bitte einen Gültigkeitsbeginn eingeben.",
  "employments.form.problems.validToBeforeValidFrom": "Die Gültigkeit endet vor ihrem Beginn.",
  "employments.form.problems.weeklyHours": "Die Wochenstunden müssen eine Zahl sein, zum Beispiel 38,5.",
  "employments.form.problems.workScheduleId": "Bitte ein Zeitmodell wählen. Ohne eines plant nichts die Tage dieser Person.",
  "employments.list.noMatch": "Kein Dienstverhältnis passt zur Suche.",
  "employments.list.search": "Nach Nummer oder Name suchen",
  "employments.onlyOnCompany": "Dienstverhältnisse werden auf einer Firma angelegt. Wählen Sie oben eine Firma aus.",
  "employments.organizationUnit": "Organisationseinheit",
  "nav.chart.month.apr": "Apr",
  "nav.chart.month.aug": "Aug",
  "nav.chart.month.dec": "Dez",
  "nav.chart.month.feb": "Feb",
  "nav.chart.month.jan": "Jan",
  "nav.chart.month.jul": "Jul",
  "nav.chart.month.jun": "Jun",
  "nav.chart.month.mar": "Mär",
  "nav.chart.month.may": "Mai",
  "nav.chart.month.nov": "Nov",
  "nav.chart.month.oct": "Okt",
  "nav.chart.month.sep": "Sep",
  "nav.chart.range.month": "Arbeitszeit diesen Monat",
  "nav.chart.range.week": "Arbeitszeit diese Woche",
  "nav.chart.range.year": "Arbeitszeit dieses Jahr",
  "nav.chart.week.kw1": "KW 1",
  "nav.chart.week.kw2": "KW 2",
  "nav.chart.week.kw3": "KW 3",
  "nav.chart.week.kw4": "KW 4",
  "nav.chart.weekday.fri": "Fr",
  "nav.chart.weekday.mon": "Mo",
  "nav.chart.weekday.sat": "Sa",
  "nav.chart.weekday.sun": "So",
  "nav.chart.weekday.thu": "Do",
  "nav.chart.weekday.tue": "Di",
  "nav.chart.weekday.wed": "Mi",
  "nav.dashboard.title": "Dashboard",
  "nav.mobile.close": "Schließen",
  "nav.mobile.closeMenu": "Menü schließen",
  "nav.mobile.mainNavigation": "Hauptnavigation",
  "nav.mobile.menu": "Menü",
  "nav.mobile.more": "Mehr",
  "nav.mobile.moreSubtitle": "Weitere Bereiche",
  "nav.primary.home": "Home",
  "nav.primary.orgChart": "Organigramm",
  "nav.primary.payScale": "Kollektivvertrag",
  "nav.primary.payScale.short": "KV",
  "nav.primary.persons": "Personen",
  "nav.primary.plan": "Plan",
  "nav.primary.settings": "Einstellungen",
  "nav.primary.time": "Zeit",
  "nav.secondary.payScale.grades": "Gehaltsgruppen",
  "nav.secondary.payScale.levels": "KV-Stufen",
  "nav.secondary.payScale.scales": "Kollektivverträge",
  "nav.secondary.persons.grid": "Personenliste",
  "nav.secondary.persons.profile": "Profil",
  "nav.secondary.persons.settings": "Einstellungen",
  "nav.secondary.persons.skills": "Fähigkeiten",
  "nav.secondary.plan.overview": "Übersicht",
  "nav.secondary.plan.schedule": "Schichtplan",
  "nav.secondary.settings.accounts": "Benutzer",
  "nav.secondary.settings.general": "Einstellungen",
  "nav.secondary.settings.organizations": "Organisationen",
  "nav.secondary.settings.profile": "Profil",
  "nav.secondary.settings.roles": "Rollen",
  "nav.secondary.settings.textCatalog": "Textkatalog",
  "nav.secondary.time.absences": "Abwesenheiten",
  "nav.secondary.time.accounts": "Zeitkonten",
  "nav.secondary.time.runs": "Verarbeitung starten",
  "nav.secondary.time.runsLog": "Laufprotokoll",
  "nav.secondary.time.tracking": "Zeiterfassung",
  "nav.topbar.apps": "Apps",
  "nav.topbar.brand": "Workforce",
  "nav.topbar.home": "Workforce Startseite",
  "nav.topbar.language": "Sprache",
  "nav.topbar.openMenu": "Menü öffnen",
  "organigram.delete.confirm": "Löschen",
  "organigram.delete.messageAssignment": "Möchten Sie diese Person wirklich von der Stelle entfernen?",
  "organigram.delete.messageOe": "Möchten Sie diese Organisationseinheit wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
  "organigram.delete.messagePosition": "Möchten Sie diese Stelle wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
  "organigram.delete.messageStation": "Möchten Sie diese Station wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
  "organigram.delete.title": "Löschen bestätigen",
  "organigram.empty": "Keine Organisationsstruktur vorhanden.",
  "organigram.errors.childrenNotAllowed": "Die Einheiten unter dieser hier dürften unter der neuen Art nicht liegen. Erst verschieben, dann die Art ändern.",
  "organigram.errors.companyEmploys": "An dieser Einheit hängen Dienstverhältnisse. Sie muss eine Firma bleiben.",
  "organigram.errors.deleteFailed": "Löschen fehlgeschlagen.",
  "organigram.errors.loadFailed": "Organigramm konnte nicht geladen werden.",
  "organigram.errors.moveFailed": "Verschieben fehlgeschlagen.",
  "organigram.errors.parentTakesNoChildren": "Unter dieser Einheit liegen keine weiteren Einheiten.",
  "organigram.errors.positionsNotAllowed": "An dieser Einheit hängen Stellen. Die neue Art trägt keine.",
  "organigram.errors.rootTakesOne": "Die Organisation hat ihre Firma bereits. Weitere Einheiten kommen darunter.",
  "organigram.errors.saveFailed": "Speichern fehlgeschlagen.",
  "organigram.errors.stationsNotAllowed": "An dieser Einheit hängen Stationen. Die neue Art trägt keine.",
  "organigram.errors.typeNotAllowedUnderParent": "Diese Art von Einheit darf dort nicht liegen. Der Aufbau ist: Wurzel → Firma → Profitcenter → Abteilung.",
  "organigram.node.add": "Hinzufügen",
  "organigram.node.addOe": "Organisationseinheit",
  "organigram.node.addOeTooltip": "Organisationseinheit hinzufügen",
  "organigram.node.addPerson": "Person zuordnen",
  "organigram.node.addPosition": "Stelle",
  "organigram.node.addStation": "Station",
  "organigram.node.deleteOe": "Organisationseinheit löschen",
  "organigram.node.deletePosition": "Stelle löschen",
  "organigram.node.deleteStation": "Station löschen",
  "organigram.node.editPosition": "Stelle bearbeiten",
  "organigram.node.editStation": "Station bearbeiten",
  "organigram.node.locked": "Gesperrt (juristische Einheit)",
  "organigram.node.settings": "Konfiguration",
  "organigram.node.viewPermissions": "View permissions",
  "organigram.oe.positionOne": "Stelle",
  "organigram.oe.positionOther": "Stellen",
  "organigram.oe.stationOne": "Station",
  "organigram.oe.stationOther": "Stationen",
  "organigram.oeType.company": "Firma",
  "organigram.oeType.department": "Abteilung",
  "organigram.oeType.organization": "Organisation (Wurzel)",
  "organigram.oeType.profitCenter": "Profitcenter",
  "organigram.panel.actions.cancel": "Abbrechen",
  "organigram.panel.actions.delete": "Löschen",
  "organigram.panel.actions.save": "Speichern",
  "organigram.panel.actions.saving": "Speichern …",
  "organigram.panel.errors.loadingPermissions": "Could not load permissions",
  "organigram.panel.fields.countryCode": "Land",
  "organigram.panel.fields.countryCodeNone": "Kein Land",
  "organigram.panel.fields.description": "Beschreibung (optional)",
  "organigram.panel.fields.legalName": "Juristischer Name (optional)",
  "organigram.panel.fields.name": "Name",
  "organigram.panel.fields.person": "Person",
  "organigram.panel.fields.personPlaceholder": "Bitte wählen …",
  "organigram.panel.fields.primary": "Als Hauptstelle",
  "organigram.panel.fields.responsiblePerson": "Verantwortlicher",
  "organigram.panel.fields.responsiblePersonChosen": "Gewählt:",
  "organigram.panel.fields.responsiblePersonClear": "entfernen",
  "organigram.panel.fields.responsiblePersonNone": "Keine Person gefunden.",
  "organigram.panel.fields.responsiblePersonSearch": "Person suchen …",
  "organigram.panel.fields.roles": "Rollen",
  "organigram.panel.fields.timezone": "Zeitzone",
  "organigram.panel.fields.timezoneHint": "Bestimmt, was eine Regel unter einer Uhrzeit wie „nicht vor 08:30“ versteht.",
  "organigram.panel.fields.timezoneInherited": "Wie übergeordnete Einheit",
  "organigram.panel.fields.type": "Typ",
  "organigram.panel.fields.vacationInherited": "— von der übergeordneten Einheit —",
  "organigram.panel.fields.vacationWaitingPeriodHint": "Leer lassen, um den Wert der übergeordneten Einheit zu übernehmen. 0 bedeutet Anspruch ab dem ersten Tag.",
  "organigram.panel.fields.vacationWaitingPeriodMonths": "Wartezeit bis zum ersten Anspruch (Monate)",
  "organigram.panel.fields.vacationYearType": "Urlaubsjahr",
  "organigram.panel.noPersons": "Keine Personen in dieser Organisation gefunden.",
  "organigram.panel.noRoles": "Keine Rollen verfügbar.",
  "organigram.panel.permissions.all": "Alle",
  "organigram.panel.removeRole": "Rolle entfernen",
  "organigram.panel.rolePlaceholder": "Rolle hinzufügen …",
  "organigram.panel.settings.accounts": "Konten",
  "organigram.panel.settings.backToSections": "Zurück zur Übersicht",
  "organigram.panel.settings.bookingTypes": "Buchungsarten",
  "organigram.panel.settings.costCenters": "Kostenstellen",
  "organigram.panel.settings.dayPrograms": "Tagesprogramme",
  "organigram.panel.settings.employments": "Dienstverhältnisse",
  "organigram.panel.settings.groups.costAccounting": "Kostenrechnung",
  "organigram.panel.settings.groups.employment": "Dienstverhältnisse",
  "organigram.panel.settings.groups.hints.costAccounting": "Kostenstellen, auf die Zeit gebucht wird",
  "organigram.panel.settings.groups.hints.employment": "Wer bei dieser Firma angestellt ist",
  "organigram.panel.settings.groups.hints.timeManagement": "Buchungsarten, Zeitarten, Konten und Regelwerk",
  "organigram.panel.settings.groups.hints.unit": "Bezeichnung, Art, Zeitzone und Kernzeit",
  "organigram.panel.settings.groups.timeManagement": "Zeitwirtschaft",
  "organigram.panel.settings.hints.accounts": "Salden wie Gleitzeit und Überstunden",
  "organigram.panel.settings.hints.bookingTypes": "Aus welchen Gründen gestempelt werden kann",
  "organigram.panel.settings.hints.costCenters": "Auf welche Kostenstellen Zeit gebucht wird",
  "organigram.panel.settings.hints.dayPrograms": "Wie ein Arbeitstag geplant verläuft",
  "organigram.panel.settings.hints.employments": "Verträge der Angestellten dieser Firma",
  "organigram.panel.settings.hints.publicHolidays": "Welche Feiertage gelten und ob halb oder ganz",
  "organigram.panel.settings.hints.rules": "Die Regeln, die aus Stempelungen Salden machen",
  "organigram.panel.settings.hints.timeTypes": "Wie erfasste Zeit bewertet wird",
  "organigram.panel.settings.hints.workSchedules": "Welchem Tagesprogramm jeder Wochentag folgt",
  "organigram.panel.settings.inherited": "Diese Abteilung erbt ihre Konfiguration. Gepflegt wird sie auf der Firma oder der Organisation darüber.",
  "organigram.panel.settings.publicHolidays": "Feiertage",
  "organigram.panel.settings.root": "Konfiguration",
  "organigram.panel.settings.rules": "Regelwerk",
  "organigram.panel.settings.timeTypes": "Zeitarten",
  "organigram.panel.settings.workSchedules": "Zeitmodelle",
  "organigram.panel.title.assignPerson": "Person zuordnen",
  "organigram.panel.title.createOe": "Organisationseinheit hinzufügen",
  "organigram.panel.title.createPosition": "Stelle hinzufügen",
  "organigram.panel.title.createStation": "Station hinzufügen",
  "organigram.panel.title.editOe": "Organisationseinheit bearbeiten",
  "organigram.panel.title.editPosition": "Stelle bearbeiten",
  "organigram.panel.title.editStation": "Station bearbeiten",
  "organigram.panel.title.settings": "Konfiguration",
  "organigram.panel.title.viewPermissions": "Rechte der Stelle",
  "organigram.panel.vacationYear.calendarYear": "Kalenderjahr",
  "organigram.panel.vacationYear.workYear": "Arbeitsjahr",
  "organigram.panel.validation.descriptionMaxLength": "Beschreibung ist zu lang.",
  "organigram.panel.validation.legalNameMaxLength": "Juristischer Name ist zu lang.",
  "organigram.panel.validation.nameMaxLength": "Name ist zu lang.",
  "organigram.panel.validation.nameRequired": "Name ist erforderlich.",
  "organigram.panel.validation.vacationWaitingPeriodRange": "Bitte eine ganze Zahl von 0 bis 120 eingeben, oder leer lassen zum Erben.",
  "organigram.position.empty": "Keine Besetzung",
  "organigram.position.label": "Stelle",
  "organigram.position.more": "Weitere Aktionen",
  "organigram.position.personOne": "Person",
  "organigram.position.personOther": "Personen",
  "organigram.position.roleOne": "Rolle",
  "organigram.position.roleOther": "Rollen",
  "organigram.row.openPerson": "Person öffnen",
  "organigram.row.primary": "Hauptstelle",
  "organigram.row.removeAssignment": "Zuordnung entfernen",
  "organigram.row.secondary": "Stellenbesetzung",
  "organigram.title": "Organigramm",
  "organigram.toolbar.all": "Alle",
  "organigram.toolbar.arrange": "Anordnen",
  "organigram.toolbar.arrangeHint": "Organigramm wieder so anordnen wie beim Laden",
  "organigram.toolbar.collapseAll": "Alles zuklappen",
  "organigram.toolbar.collapsePositions": "Stellen aller Einheiten ausblenden",
  "organigram.toolbar.expandAll": "Stellen, Personen und Stationen aufklappen",
  "organigram.toolbar.expandPositions": "Stellen aller Einheiten anzeigen",
  "organigram.toolbar.positions": "Stellen",
  "organigram.zoom.fit": "Organigramm einpassen",
  "organigram.zoom.in": "Vergrößern",
  "organigram.zoom.out": "Verkleinern",
  "organigram.zoom.reset": "Zoom auf 100% zurücksetzen",
  "organization.entity.group.people": "People",
  "organization.entity.group.structure": "Structure",
  "organization.entity.organigram": "Organigramm",
  "organization.entity.organizationUnit": "Organization Unit",
  "organization.entity.person": "Person",
  "organization.entity.personPosition": "Person Position",
  "organization.entity.position": "Position",
  "organization.persons.actions.addAndInvite": "Person hinzufügen & einladen",
  "organization.persons.actions.creating": "Wird angelegt…",
  "organization.persons.actions.resendInvite": "Einladung erneut senden",
  "organization.persons.confirmRemove": "{{name}} wirklich aus dieser Organisation entfernen?",
  "organization.persons.empty": "Noch keine Personen in dieser Organisation.",
  "organization.persons.errors.createFailed": "Person konnte nicht angelegt werden.",
  "organization.persons.errors.removeFailed": "Person konnte nicht entfernt werden.",
  "organization.persons.errors.resendFailed": "Einladung konnte nicht erneut gesendet werden.",
  "organization.persons.fields.email": "E-Mail",
  "organization.persons.fields.firstName": "Vorname",
  "organization.persons.fields.isOwner": "Als Admin / Eigentümer der Organisation",
  "organization.persons.fields.lastName": "Nachname",
  "organization.persons.inviteLink": "Link",
  "organization.persons.inviteSent": "Einladung an {{email}} verschickt.",
  "organization.persons.loading": "Personen werden geladen…",
  "organization.persons.status.invited": " · eingeladen",
  "organization.persons.status.linked": " · verknüpft",
  "organization.persons.title": "Personen",
  "payScale.grades.actions.create": "Gehaltsgruppe erstellen",
  "payScale.grades.actions.edit": "Bearbeiten",
  "payScale.grades.actions.saving": "Wird gespeichert…",
  "payScale.grades.columns.code": "Kurzbezeichnung",
  "payScale.grades.columns.employmentRelationship": "Dienstnehmergruppe",
  "payScale.grades.columns.name": "Bezeichnung",
  "payScale.grades.columns.payScale": "Kollektivvertrag",
  "payScale.grades.columns.validFrom": "Gültig ab",
  "payScale.grades.description": "Verwalten Sie die Gehaltsgruppen Ihrer Kollektivverträge.",
  "payScale.grades.details.code": "Kurzbezeichnung",
  "payScale.grades.details.employmentRelationship": "Dienstnehmergruppe",
  "payScale.grades.details.loading": "Gehaltsgruppe wird geladen…",
  "payScale.grades.details.name": "Bezeichnung",
  "payScale.grades.details.payScale": "Kollektivvertrag",
  "payScale.grades.details.sections.info": "Gehaltsgruppe",
  "payScale.grades.details.validFrom": "Gültig ab",
  "payScale.grades.details.validTo": "Gültig bis",
  "payScale.grades.form.createTitle": "Gehaltsgruppe erstellen",
  "payScale.grades.form.editTitle": "Gehaltsgruppe bearbeiten",
  "payScale.grades.form.fields.code": "Kurzbezeichnung",
  "payScale.grades.form.fields.employmentRelationship": "Dienstnehmergruppe",
  "payScale.grades.form.fields.name": "Bezeichnung",
  "payScale.grades.form.fields.payScale": "Kollektivvertrag",
  "payScale.grades.form.fields.validFrom": "Gültig ab",
  "payScale.grades.form.fields.validTo": "Gültig bis",
  "payScale.grades.form.loading": "Gehaltsgruppe wird geladen…",
  "payScale.grades.form.validation.codeMaxLength": "Kurzbezeichnung ist zu lang",
  "payScale.grades.form.validation.codeRequired": "Kurzbezeichnung ist erforderlich",
  "payScale.grades.form.validation.employmentRelationshipRequired": "Dienstnehmergruppe ist erforderlich",
  "payScale.grades.form.validation.nameMaxLength": "Bezeichnung ist zu lang",
  "payScale.grades.form.validation.nameRequired": "Bezeichnung ist erforderlich",
  "payScale.grades.form.validation.payScaleRequired": "Kollektivvertrag ist erforderlich",
  "payScale.grades.form.validation.validFromRequired": "„Gültig ab“ ist erforderlich",
  "payScale.grades.list.placeholderDescription": "Wählen Sie eine Gehaltsgruppe aus der Tabelle, um Details anzuzeigen.",
  "payScale.grades.list.placeholderTitle": "Gehaltsgruppen",
  "payScale.grades.title": "Gehaltsgruppen",
  "payScale.levels.actions.create": "Stufe erstellen",
  "payScale.levels.actions.edit": "Bearbeiten",
  "payScale.levels.actions.saving": "Wird gespeichert…",
  "payScale.levels.advanceInfoMonths": "Vorrückung nach {{months}} M.",
  "payScale.levels.advanceInfoYears": "Vorrückung nach {{years}} J.",
  "payScale.levels.columns.amount": "Betrag",
  "payScale.levels.columns.levelName": "Stufe",
  "payScale.levels.columns.payGrade": "Gehaltsgruppe",
  "payScale.levels.columns.validFrom": "Gültig ab",
  "payScale.levels.description": "Verwalten Sie die Gehaltsstufen innerhalb jeder Gehaltsgruppe.",
  "payScale.levels.details.advance": "Vorrückung",
  "payScale.levels.details.amount": "Betrag",
  "payScale.levels.details.levelName": "Stufe",
  "payScale.levels.details.loading": "Stufe wird geladen…",
  "payScale.levels.details.nextGrade": "Nächste Gruppe",
  "payScale.levels.details.nextLevel": "Nächste Stufe",
  "payScale.levels.details.payGrade": "Gehaltsgruppe",
  "payScale.levels.details.sections.info": "Stufe",
  "payScale.levels.details.validFrom": "Gültig ab",
  "payScale.levels.details.validTo": "Gültig bis",
  "payScale.levels.form.createTitle": "Stufe erstellen",
  "payScale.levels.form.editTitle": "Stufe bearbeiten",
  "payScale.levels.form.fields.advanceAfterMonths": "Vorrückung nach Monaten",
  "payScale.levels.form.fields.advanceAfterYears": "Vorrückung nach Jahren",
  "payScale.levels.form.fields.amount": "Betrag",
  "payScale.levels.form.fields.levelName": "Stufe",
  "payScale.levels.form.fields.nextGrade": "Nächste Gruppe",
  "payScale.levels.form.fields.nextLevel": "Nächste Stufe",
  "payScale.levels.form.fields.none": "—",
  "payScale.levels.form.fields.payGrade": "Gehaltsgruppe",
  "payScale.levels.form.fields.payScale": "Kollektivvertrag",
  "payScale.levels.form.fields.validFrom": "Gültig ab",
  "payScale.levels.form.fields.validTo": "Gültig bis",
  "payScale.levels.form.loading": "Stufe wird geladen…",
  "payScale.levels.form.validation.amountRequired": "Betrag ist erforderlich",
  "payScale.levels.form.validation.levelNameRequired": "Stufe ist erforderlich",
  "payScale.levels.form.validation.payGradeRequired": "Gehaltsgruppe ist erforderlich",
  "payScale.levels.form.validation.validFromRequired": "„Gültig ab“ ist erforderlich",
  "payScale.levels.list.placeholderDescription": "Wählen Sie eine Stufe aus der Tabelle, um Details anzuzeigen.",
  "payScale.levels.list.placeholderTitle": "KV-Stufen",
  "payScale.levels.title": "KV-Stufen",
  "permission.action.create": "Create",
  "permission.action.delete": "Delete",
  "permission.action.read": "Read",
  "permission.action.sendInvite": "Einladung senden können",
  "permission.action.update": "Update",
  "permission.matrix.action": "Aktion",
  "permission.matrix.entity": "Entity / Action",
  "permission.scope.all": "All",
  "permission.scope.child_oe": "Child OE",
  "permission.scope.own": "Own",
  "permission.scope.same_oe": "Same OE",
  "permission.scope.same_position": "Same Position",
  "persons.form.placeholders.city": "Ort eingeben",
  "persons.form.placeholders.country": "Land eingeben",
  "persons.form.placeholders.personnelNumber": "Personalnummer eingeben",
  "persons.form.placeholders.postalCode": "Postleitzahl eingeben",
  "persons.form.placeholders.privateMobile": "Private Mobilnummer eingeben",
  "persons.form.placeholders.socialSecurityNumber": "SV-Nummer eingeben",
  "persons.form.placeholders.street": "Straße eingeben",
  "persons.form.placeholders.vacationDays": "Urlaubstage eingeben",
  "persons.form.validation.cityMaxLength": "Ort darf höchstens 100 Zeichen lang sein",
  "persons.form.validation.countryMaxLength": "Land darf höchstens 100 Zeichen lang sein",
  "persons.form.validation.personnelNumberMaxLength": "Personalnummer darf höchstens 50 Zeichen lang sein",
  "persons.form.validation.postalCodeMaxLength": "Postleitzahl darf höchstens 20 Zeichen lang sein",
  "persons.form.validation.socialSecurityNumberMaxLength": "SV-Nummer darf höchstens 50 Zeichen lang sein",
  "persons.form.validation.streetMaxLength": "Straße darf höchstens 255 Zeichen lang sein",
  "persons.list.actions.create": "Person anlegen",
  "persons.list.actions.edit": "Bearbeiten",
  "persons.list.actions.deletePerson": "Person löschen",
  "persons.list.actions.saving": "Speichern…",
  "persons.list.actions.sendInvite": "Einladung senden",
  "persons.list.columns.email": "E-Mail",
  "persons.list.columns.name": "Name",
  "persons.list.columns.type": "Typ",
  "persons.list.description": "Personen in der ausgewählten Organisation anzeigen und verwalten.",
  "persons.list.details.loading": "Person wird geladen…",
  "persons.list.details.sections.account": "Konto",
  "persons.list.details.sections.address": "Anschrift",
  "persons.list.details.sections.administration": "Verwaltung",
  "persons.list.details.sections.email": "eMail",
  "persons.list.details.sections.meta": "Metadaten",
  "persons.list.details.sections.socialSecurityReports": "SV-Meldungen",
  "persons.list.details.sections.socialSecurityReportsEmpty": "Keine SV-Meldungen vorhanden.",
  "persons.list.fields.accountStatus": "Kontostatus",
  "persons.list.fields.city": "Ort",
  "persons.list.fields.country": "Land",
  "persons.list.fields.mobile": "Mobil",
  "persons.list.fields.personnelNumber": "Personalnummer",
  "persons.list.fields.postalCode": "Postleitzahl",
  "persons.list.fields.privateEmail": "eMail (Privat)",
  "persons.list.fields.privateMobile": "Privat (m)",
  "persons.list.fields.socialSecurityNumber": "SV-Nummer",
  "persons.list.fields.street": "Straße",
  "persons.list.fields.vacationDays": "Urlaubstage",
  "persons.list.form.createTitle": "Person anlegen",
  "persons.list.form.editTitle": "Person bearbeiten",
  "persons.list.form.loading": "Person wird geladen…",
  "persons.list.form.placeholders.city": "Ort eingeben",
  "persons.list.form.placeholders.country": "Land eingeben",
  "persons.list.form.placeholders.employmentRelationship": "Dienstnehmergruppe eingeben",
  "persons.list.form.placeholders.employmentScopePercent": "z. B. 100",
  "persons.list.form.placeholders.personnelNumber": "Personalnummer eingeben",
  "persons.list.form.placeholders.postalCode": "Postleitzahl eingeben",
  "persons.list.form.placeholders.privateMobile": "Private Mobilnummer eingeben",
  "persons.list.form.placeholders.socialSecurityNumber": "SV-Nummer eingeben",
  "persons.list.form.placeholders.street": "Straße eingeben",
  "persons.list.form.placeholders.vacationDays": "Urlaubstage eingeben",
  "persons.list.invite.sent": "Einladung an {{email}} gesendet.",
  "persons.list.noOrganization.description": "Wählen Sie in der Kontextumschaltung eine Organisation, um Personen anzuzeigen.",
  "persons.list.noOrganization.title": "Keine Organisation ausgewählt",
  "persons.list.placeholderDescription": "Wählen Sie eine Person in der Tabelle, um Details in der Seitenleiste anzuzeigen.",
  "persons.list.placeholderTitle": "Personen",
  "persons.list.status.invited": "Eingeladen (ausstehend)",
  "persons.list.status.linked": "Mit Benutzerkonto verknüpft",
  "persons.list.tabs.details": "Detail",
  "persons.list.tabs.settings": "Verwaltung",
  "persons.list.tabs.skills": "Fähigkeiten",
  "persons.list.unlink.action": "Konto trennen",
  "persons.list.unlink.confirmDescription": "Diese Person wird nicht mehr mit dem Benutzerkonto verknüpft. Das Benutzerkonto selbst wird nicht gelöscht.",
  "persons.list.unlink.confirmTitle": "Benutzerkonto trennen?",
  "persons.list.unlink.loading": "Wird getrennt…",
  "persons.list.unlink.success": "Person vom Benutzerkonto getrennt.",
  "persons.profile.assignments.empty.description": "Sie sind mit dieser Organisation verknüpft, aber noch keiner Position zugewiesen. Ein Administrator muss Sie im Organigramm platzieren, um Ihnen Zugriff zu gewähren.",
  "persons.profile.assignments.empty.title": "Noch nicht im Organigramm platziert",
  "persons.profile.assignments.noRoles": "Keine Rollen",
  "persons.profile.assignments.primary": "Primär",
  "persons.profile.assignments.rolesLabel": "Rollen",
  "persons.profile.fields.account": "Konto",
  "persons.profile.fields.company": "Unternehmen",
  "persons.profile.fields.createdAt": "Erstellt am",
  "persons.profile.fields.email": "E-Mail",
  "persons.profile.fields.personId": "Personen-ID",
  "persons.profile.fields.phone": "Telefon",
  "persons.profile.fields.type": "Typ",
  "persons.profile.loading": "Profil wird geladen …",
  "persons.profile.noOrganization.description": "Wählen Sie eine Organisation im Kontext-Switcher, um Ihr Profil anzuzeigen.",
  "persons.profile.noOrganization.title": "Keine Organisation ausgewählt",
  "persons.profile.noPerson.description": "Für diese Organisation ist keine Person mit Ihrem Benutzerkonto verknüpft.",
  "persons.profile.noPerson.title": "Keine Person in dieser Organisation",
  "persons.profile.sections.assignments": "Positionen & Rollen",
  "persons.profile.sections.contact": "Kontakt",
  "persons.profile.sections.meta": "Metadaten",
  "persons.profile.title": "Profil",
  "processing.closing.alreadyClosed": "Dieser Zeitraum ist bereits abgeschlossen.",
  "processing.closing.blockedByContracts": "Abschluss nicht möglich: {{count}} von {{seen}} Verträgen haben einen Fehler. Der Rest ist gespeichert.",
  "processing.closing.close": "{{period}} abschließen",
  "processing.closing.hint": "Ein Abschluss sperrt den Zeitraum und hält die Kontostände fest. Wieder öffnen löscht nichts: der Abschluss wird als zurückgenommen geführt und bleibt sichtbar.",
  "processing.closing.needsCompletedRun": "Ein Abschluss braucht einen erfolgreich beendeten Lauf.",
  "processing.closing.reopen": "Wieder öffnen",
  "processing.closing.snapshots": "{{count}} Kontostände festgehalten",
  "processing.closing.title": "Abschluss",
  "processing.log.covers": "{{days}} Tage · {{contracts}} Dienstverhältnisse",
  "processing.log.days.title": "Tage und Dienstverhältnisse",
  "processing.log.days.none": "Dieser Lauf war für keinen einzigen Tag zuständig.",
  "processing.log.days.date": "Datum",
  "processing.log.days.employment": "Dienstverhältnis",
  "processing.log.days.status": "Status",
  "processing.log.days.statuses.SUCCEEDED": "Erfolgreich",
  "processing.log.days.statuses.FAILED": "Fehler",
  "processing.log.days.statuses.SKIPPED": "Übersprungen",
  "processing.log.days.reason": "Erklärung",
  "processing.log.days.segments": "Abschnitte",
  "processing.log.days.entries": "Buchungen",
  "processing.log.days.warnings": "Hinweise",
  "processing.log.newRun": "Neue Verarbeitung",
  "processing.log.run": "Lauf",
  "processing.log.subtitle": "Laufstatus bis auf Personen- und Tagesebene, statt eines undifferenzierten Gesamtfehlers.",
  "processing.log.totals.succeeded": "Erfolgreiche Tage",
  "processing.log.totals.failed": "Fehlerhafte Tage",
  "processing.log.totals.skipped": "Übersprungene Tage",
  "processing.log.totals.dependent": "Abhängige Folgetage",
  "processing.messages.ABSENCE_ALREADY_BOOKED": "Abwesenheit war bereits gebucht",
  "processing.messages.ABSENCE_ENTERED_BY_HAND": "Abwesenheit von Hand erfasst",
  "processing.messages.ABSENCE_NO_TIME_TYPE": "Abwesenheit ohne Zeitart",
  "processing.messages.ABSENCE_SPAN_WITHDRAWN": "Abwesenheitszeitraum zurückgezogen",
  "processing.messages.ABSENCE_UNKNOWN_TIME_TYPE": "Abwesenheit mit unbekannter Zeitart",
  "processing.messages.ABSENCE_VALUED": "Abwesenheit bewertet",
  "processing.messages.ABSENCE_WITHOUT_SEGMENT": "Abwesenheit ohne Zeitabschnitt",
  "processing.messages.ACCOUNT_ALREADY_AT_VALUE": "Konto steht bereits auf diesem Wert",
  "processing.messages.AMBIGUOUS_SEGMENT_START": "Mehrdeutiger Beginn eines Zeitabschnitts",
  "processing.messages.BOOKING_NO_ACCOUNT": "Buchung ohne Konto",
  "processing.messages.BOOKING_NO_AMOUNT": "Buchung ohne Betrag",
  "processing.messages.BOOKING_NO_VALUATION": "Buchung ohne Bewertung",
  "processing.messages.BREAK_RULE_NO_THRESHOLD": "Pausenregel ohne Schwelle",
  "processing.messages.BREAK_SHORTFALL_DEDUCTED": "Fehlende Pause abgezogen",
  "processing.messages.BREAK_SHORTFALL_UNCOVERED": "Fehlende Pause nicht gedeckt",
  "processing.messages.CATCH_UP_DAYS_ADDED": "Frühere Tage nachgeholt",
  "processing.messages.CATCH_UP_LIMIT_REACHED": "Nachholgrenze erreicht, Resttage bleiben offen",
  "processing.messages.CLOSURE_DAY_LOCKED": "Tag durch Abschluss gesperrt",
  "processing.messages.CONDITION_NOT_EVALUABLE": "Bedingung nicht auswertbar",
  "processing.messages.CLOSURE_AFTER_FAILED_DAY": "Abschlussphase nicht gelaufen — der Zeitraum hat eine Lücke",
  "processing.messages.CORRECTION_NOT_IMPLEMENTED": "Korrektur nicht umgesetzt",
  "processing.messages.CORRECTION_NO_SEGMENT": "Korrektur fand keinen Zeitabschnitt",
  "processing.messages.CORRECTION_NO_TIME": "Korrektur ohne gültige Uhrzeit",
  "processing.messages.DAILY_DURATION_LIMIT_REACHED": "Tageshöchstdauer erreicht",
  "processing.messages.DAILY_LIMIT_NOT_READABLE": "Tageshöchstdauer nicht lesbar",
  "processing.messages.DAY_FAILED": "Tag fehlgeschlagen",
  "processing.messages.DAY_LOCKED": "Tag gesperrt",
  "processing.messages.DAY_PLAN_MISSING": "Kein Tagesprogramm",
  "processing.messages.DEPENDENT_DAY_SKIPPED": "Übersprungen — ein früherer Tag dieses Dienstverhältnisses ist fehlgeschlagen",
  "processing.messages.DEPENDENT_DAYS_ADDED": "Abhängige Folgetage neu berechnet",
  "processing.messages.EARLIER_ENTRIES_REVERSED": "Buchungen eines früheren Laufs storniert",
  "processing.messages.EARLIEST_START_APPLIED": "Frühester Beginn angewendet",
  "processing.messages.EMPLOYMENT_FAILED": "Dienstverhältnis fehlgeschlagen",
  "processing.messages.NO_SEGMENTATION_RULES": "Keine Segmentierungsregeln",
  "processing.messages.OPEN_SEGMENT_AFTER_CORRECTIONS": "Offener Zeitabschnitt nach den Korrekturen",
  "processing.messages.OVERLAPPING_SEGMENT_START": "Überlappender Beginn eines Zeitabschnitts",
  "processing.messages.RULE_MESSAGE": "Meldung aus dem Regelwerk",
  "processing.messages.RULE_SET_INHERITED": "Regelwerk von einer übergeordneten Einheit",
  "processing.messages.RULE_SET_NOT_COMPILED": "Regelwerk nicht übersetzt",
  "processing.messages.SECTION_RULE_NO_ACCOUNT": "Abschnittsregel ohne Konto",
  "processing.messages.SECTION_RULE_WRONG_PHASE": "Abschnittsregel in der falschen Phase",
  "processing.messages.SEGMENT_CREATED": "Zeitabschnitt vom Regelwerk angelegt",
  "processing.messages.SEGMENT_NOT_CLOSED": "Zeitabschnitt nicht geschlossen",
  "processing.messages.SEGMENT_NOT_FORWARD": "Zeitabschnitt läuft rückwärts",
  "processing.messages.SEGMENT_NO_END": "Zeitabschnitt ohne Ende",
  "processing.messages.SEGMENT_NO_START": "Zeitabschnitt ohne Beginn",
  "processing.messages.SEGMENT_NO_TIME_TYPE": "Zeitabschnitt ohne Zeitart",
  "processing.messages.SEGMENT_UNKNOWN_TIME_TYPE": "Zeitabschnitt mit unbekannter Zeitart",
  "processing.messages.STATEMENT_NOT_IMPLEMENTED": "Anweisung noch nicht umgesetzt",
  "processing.messages.TIMEZONE_FALLBACK": "Ersatzzeitzone verwendet",
  "processing.messages.TRANSFER_INCOMPLETE": "Umbuchung unvollständig",
  "processing.messages.UNKNOWN_ACCOUNT": "Unbekanntes Konto",
  "processing.messages.UNKNOWN_TIME_TYPE": "Unbekannte Zeitart",
  "processing.messages.UNUSED_BOOKING": "Buchung nicht verwendet",
  "processing.messages.VARIABLE_NOT_RESOLVED": "Variable nicht aufgelöst",
  "processing.overview.covers": "Über diese Einheit und alles darunter — {{count}} Einheiten. Ein Lauf deckt nur die gewählte ab.",
  "processing.overview.errors.loadFailed": "Die Kennzahlen konnten nicht geladen werden.",
  "processing.overview.lastProcessed": "Zuletzt verarbeitet",
  "processing.overview.lastProcessedHint": "jüngster beendeter Lauf",
  "processing.overview.never": "noch nie",
  "processing.overview.openDays": "Offene Tage",
  "processing.overview.openDaysHint": "bis gestern, noch von keinem sauberen Lauf erreicht",
  "processing.overview.retroactive": "Rückwirkende Korrekturen",
  "processing.overview.retroactiveHint": "gerechnete Tage, deren Buchung später kam",
  "processing.overview.withErrors": "Dienstverhältnisse mit Fehler",
  "processing.overview.withErrorsHint": "im jeweils jüngsten Lauf",
  "processing.result.bookings": "Buchungen",
  "processing.result.dayTotal": "Tagessumme",
  "processing.result.employment": "Vertrag",
  "processing.result.empty": "Dieser Lauf hat keine Segmente, Buchungen oder Meldungen erzeugt.",
  "processing.result.errorCount": "{{count}} Fehler",
  "processing.result.errors.loadFailed": "Das Ergebnis konnte nicht geladen werden.",
  "processing.result.contract.statuses.SUCCEEDED": "erfolgreich",
  "processing.result.contract.statuses.PARTIAL": "teilweise erfolgreich",
  "processing.result.contract.statuses.FAILED": "fehlgeschlagen",
  "processing.result.contract.statuses.SKIPPED": "übersprungen",
  "processing.result.contract.figures": "{{from}} – {{to}}: {{succeeded}} Tage berechnet, {{failed}} mit Fehler, {{skipped}} übersprungen, {{entries}} Buchungen",
  "processing.result.governance.inheritedFrom": "· geerbt von {{unit}}",
  "processing.result.governance.skipped.NO_RULE_SET": "Kein Regelwerk für dieses Zeitmodell — nichts berechnet",
  "processing.result.governance.skipped.NO_WORK_SCHEDULE": "Kein Zeitmodell hinterlegt — nichts berechnet",
  "processing.result.governance.skippedCount": "{{count}} Verträge ohne Regelwerk",
  "processing.result.governance.title": "Geltende Regelwerke",
  "processing.result.governance.version": "Version {{version}}",
  "processing.result.governance.workSchedule": "Zeitmodell",
  "processing.result.messageGroups.perContract": "Einzelne Verträge",
  "processing.result.messageGroups.runLevel": "Betrifft den ganzen Lauf",
  "processing.result.messages": "Meldungen",
  "processing.result.noBookings": "Dieser Lauf hat nichts gebucht.",
  "processing.result.open": "offen",
  "processing.result.phase": "Phase {{phase}}",
  "processing.result.segments": "Segmente",
  "processing.result.summary.contracts": "{{clean}} von {{seen}} Verträgen sind durchgelaufen.",
  "processing.result.summary.runLevel": "Fehler, die den ganzen Lauf betreffen: {{count}}",
  "processing.result.summary.withErrors": "Davon {{count}} mit Fehler.",
  "processing.result.superseded": "ersetzt",
  "processing.result.warningCount": "{{count}} Warnungen",
  "processing.run.configure": "Verarbeitung konfigurieren",
  "processing.run.contracts": "{{count}} Dienstverhältnisse",
  "processing.run.covers": "Erfasst {{count}} Dienstverhältnisse.",
  "processing.run.coversOne": "Erfasst ein Dienstverhältnis.",
  "processing.run.employment": "Dienstverhältnis",
  "processing.run.errors.listFailed": "Die Läufe konnten nicht geladen werden.",
  "processing.run.errors.noEmployment": "Für diese Einheit steht kein Dienstverhältnis zur Auswahl.",
  "processing.run.errors.noEmployments": "Diese Einheit hat keine Dienstverhältnisse — ein Lauf würde nichts berechnen.",
  "processing.run.errors.periodOrder": "Das Ende darf nicht vor dem Beginn liegen.",
  "processing.run.errors.startFailed": "Der Lauf konnte nicht gestartet werden.",
  "processing.run.flow.title": "Verarbeitungsablauf",
  "processing.run.flow.SEGMENTATION.title": "Segmentierung",
  "processing.run.flow.SEGMENTATION.detail": "Aus Buchungen und Abwesenheiten werden Zeitabschnitte.",
  "processing.run.flow.CORRECTIONS.title": "Korrekturen",
  "processing.run.flow.CORRECTIONS.detail": "Regeln bessern Abschnitte nach; die ersetzte Fassung bleibt lesbar.",
  "processing.run.flow.CALCULATION.title": "Berechnung",
  "processing.run.flow.CALCULATION.detail": "Pausen, Soll und Ist je Tag.",
  "processing.run.flow.BOOKINGS.title": "Buchungen",
  "processing.run.flow.BOOKINGS.detail": "Kontobewegungen. Buchungen früherer Läufe zu denselben Tagen werden storniert.",
  "processing.run.flow.CLOSURES.title": "Abschlüsse",
  "processing.run.flow.CLOSURES.detail": "Läuft bei jedem Lauf; das Regelwerk entscheidet über „on run“, was dort geschieht.",
  "processing.run.flow.synchronous": "Der Lauf hängt am Aufruf, nicht an einem Hintergrunddienst: die Seite wartet, bis er fertig ist, und öffnet dann sein Protokoll.",
  "processing.run.from": "Von",
  "processing.run.hints.recomputes": "Alle Tage von–bis werden neu berechnet, unabhängig von früheren Läufen. Buchungen früherer Läufe zu diesen Tagen werden dabei storniert.",
  "processing.run.hints.runType": "Die Laufart entscheidet nur, welche „on run“-Regeln des Regelwerks feuern. Gerechnet wird in jedem Fall jeder Tag des Zeitraums.",
  "processing.run.isolation": "Fehlerisolation: ein fehlerhafter Tag hält weder die anderen Dienstverhältnisse noch die Tage davor auf. Die Folgetage desselben Dienstverhältnisses werden übersprungen — sie rechnen auf dem fehlerhaften Tag auf.",
  "processing.run.none": "Für diese Einheit gibt es noch keine Läufe.",
  "processing.run.noUnits": "Es sind keine Organisationseinheiten verfügbar.",
  "processing.run.open": "Ansehen",
  "processing.run.openLog": "Laufprotokoll öffnen",
  "processing.run.lastRun.contracts": "{{seen}} Dienstverhältnisse, {{clean}} ohne Fehler, {{errors}} mit Fehlern",
  "processing.run.lastRun.title": "{{name}}:",
  "processing.run.outcome.SUCCEEDED": "Erfolgreich",
  "processing.run.outcome.PARTIAL": "Teilweise",
  "processing.run.outcome.FAILED": "Fehler",
  "processing.run.outcome.RUNNING": "Läuft",
  "processing.run.preview.catchUp": ", dazu {{count}} Tage, die der Lauf von sich aus nachholt",
  "processing.run.preview.catchUpDays": "+{{count}} vor dem Zeitraum",
  "processing.run.preview.check": "Vorschau prüfen",
  "processing.run.preview.days": "{{count}} Tage",
  "processing.run.preview.dependentDays": "+{{count}} danach (abhängig)",
  "processing.run.preview.empty": "Diese Einheit hat kein Dienstverhältnis.",
  "processing.run.preview.errors.failed": "Die Vorschau konnte nicht geladen werden.",
  "processing.run.preview.inherited": "· geerbt von {{unit}}",
  "processing.run.preview.locked": ", davon {{count}} durch einen Abschluss gesperrt",
  "processing.run.preview.noDays": "kein Tag im Zeitraum",
  "processing.run.preview.outsideWindow": "Zeitraum liegt außerhalb des Dienstverhältnisses",
  "processing.run.preview.period": " Zeitraum: {{days}} Tage",
  "processing.run.preview.scheduleChanges": "Zeitmodell wechselt im Zeitraum — das Regelwerk gilt für den ersten Tag",
  "processing.run.preview.summary": "{{compute}} von {{total}} Dienstverhältnissen würden gerechnet, {{skip}} übersprungen.",
  "processing.run.preview.title": "Was dieser Lauf anfassen würde",
  "processing.run.preview.version": "Version {{version}}",
  "processing.run.recent": "Letzte Läufe",
  "processing.run.scope": "Umfang",
  "processing.run.scopes.UNIT": "Ganze Organisationseinheit",
  "processing.run.scopes.EMPLOYMENT": "Einzelnes Dienstverhältnis",
  "processing.run.selectHint": "Wählen Sie oben einen Lauf, um sein Ergebnis zu sehen.",
  "processing.run.start": "Lauf starten",
  "processing.run.subtitle": "Einen Zeitraum neu berechnen lassen und frühere Läufe öffnen.",
  "processing.run.table.startedAt": "Gestartet",
  "processing.run.table.period": "Zeitraum",
  "processing.run.table.runType": "Laufart",
  "processing.run.table.scope": "Umfang",
  "processing.run.table.outcome": "Ergebnis",
  "processing.run.table.number": "Lauf-Nr.",
  "processing.run.to": "Bis",
  "processing.run.type": "Laufart",
  "processing.run.types.DAILY": "Täglich",
  "processing.run.types.PERIOD": "Zeitraum",
  "processing.run.types.RECALCULATION": "Neuberechnung",
  "processing.run.types.CLOSING": "Abschluss",
  "processing.run.unit": "Organisationseinheit",
  "settings.accounts.actions.create": "Benutzer erstellen",
  "settings.accounts.actions.edit": "Bearbeiten",
  "settings.accounts.actions.saving": "Wird gespeichert …",
  "settings.accounts.columns.email": "E-Mail",
  "settings.accounts.columns.name": "Name",
  "settings.accounts.description": "Benutzerkonten und Rollenzuweisungen verwalten.",
  "settings.accounts.details.assignedRoles": "Zugewiesene Rollen",
  "settings.accounts.details.fullName": "Vollständiger Name",
  "settings.accounts.details.loading": "Benutzer wird geladen …",
  "settings.accounts.details.noRolesAssigned": "Keine Rollen zugewiesen",
  "settings.accounts.details.sections.access": "Zugriff",
  "settings.accounts.details.sections.userInfo": "Benutzerinformationen",
  "settings.accounts.details.status": "Status",
  "settings.accounts.details.statusApproved": "Freigegeben",
  "settings.accounts.details.statusPending": "Freigabe ausstehend",
  "settings.accounts.details.userId": "Benutzer-ID",
  "settings.accounts.form.createTitle": "Benutzer erstellen",
  "settings.accounts.form.editTitle": "Benutzer bearbeiten",
  "settings.accounts.form.fields.email": "E-Mail",
  "settings.accounts.form.fields.isApproved": "Für Zugriff freigegeben",
  "settings.accounts.form.fields.isApprovedHint": "Erlaubt diesem Konto die Anmeldung in Workforce.",
  "settings.accounts.form.fields.name": "Vollständiger Name",
  "settings.accounts.form.fields.role": "Rolle",
  "settings.accounts.form.fields.roleHint": "Wählen Sie die Rolle für diesen Benutzer.",
  "settings.accounts.form.fields.roleValue.admin": "Admin",
  "settings.accounts.form.fields.roleValue.superAdmin": "Super Admin",
  "settings.accounts.form.fields.roleValue.user": "Benutzer",
  "settings.accounts.form.loading": "Benutzer wird geladen …",
  "settings.accounts.form.roles.noRolesAvailable": "Keine Rollen verfügbar",
  "settings.accounts.form.roles.selected": "ausgewählt",
  "settings.accounts.form.roles.title": "Rollen",
  "settings.accounts.form.validation.nameMaxLength": "Name ist zu lang",
  "settings.accounts.form.validation.nameRequired": "Name ist erforderlich",
  "settings.accounts.list.placeholderDescription": "Wählen Sie einen Benutzer in der Tabelle aus, um Details in der Seitenleiste anzuzeigen.",
  "settings.accounts.list.placeholderTitle": "Benutzerkonten",
  "settings.accounts.title": "Benutzer",
  "settings.organizations.actions.create": "Organisation erstellen",
  "settings.organizations.actions.edit": "Bearbeiten",
  "settings.organizations.actions.saving": "Wird gespeichert …",
  "settings.organizations.columns.createdAt": "Erstellt am",
  "settings.organizations.columns.name": "Name",
  "settings.organizations.description": "Organisationen verwalten (Power-User-Funktion).",
  "settings.organizations.details.createdAt": "Erstellt am",
  "settings.organizations.details.loading": "Organisation wird geladen …",
  "settings.organizations.details.name": "Name",
  "settings.organizations.details.organizationId": "Organisations-ID",
  "settings.organizations.details.sections.info": "Organisationsinformationen",
  "settings.organizations.form.createTitle": "Organisation erstellen",
  "settings.organizations.form.editTitle": "Organisation bearbeiten",
  "settings.organizations.form.fields.name": "Name",
  "settings.organizations.form.fields.owners": "Eigentümer / Admins",
  "settings.organizations.form.fields.ownersEmpty": "Keine Personen gefunden.",
  "settings.organizations.form.fields.ownersHint": "Ausgewählte Personen werden als Admins der Organisation hinzugefügt (Owner-Stelle in der Wurzel-OE).",
  "settings.organizations.form.fields.ownersSearch": "Personen suchen…",
  "settings.organizations.form.loading": "Organisation wird geladen …",
  "settings.organizations.form.validation.nameMaxLength": "Name ist zu lang",
  "settings.organizations.form.validation.nameRequired": "Name ist erforderlich",
  "settings.organizations.list.placeholderDescription": "Wählen Sie eine Organisation in der Tabelle aus, um Details in der Seitenleiste anzuzeigen.",
  "settings.organizations.list.placeholderTitle": "Organisationen",
  "settings.organizations.title": "Organisationen",
  "settings.payScales.actions.create": "Kollektivvertrag erstellen",
  "settings.payScales.actions.edit": "Bearbeiten",
  "settings.payScales.actions.saving": "Wird gespeichert…",
  "settings.payScales.columns.code": "Kurzbezeichnung",
  "settings.payScales.columns.name": "Bezeichnung",
  "settings.payScales.columns.validFrom": "Gültig ab",
  "settings.payScales.columns.validTo": "Gültig bis",
  "settings.payScales.columns.weeklyWorkHours": "Wochenstunden",
  "settings.payScales.description": "Kollektivverträge mit ihren Gehaltsgruppen und Stufen verwalten.",
  "settings.payScales.details.code": "Kurzbezeichnung",
  "settings.payScales.details.createdAt": "Erstellt am",
  "settings.payScales.details.dailyWorkHours": "Regelarbeitszeit Tag",
  "settings.payScales.details.loading": "Kollektivvertrag wird geladen…",
  "settings.payScales.details.monthlyWorkHours": "Regelarbeitszeit Monat",
  "settings.payScales.details.name": "Bezeichnung",
  "settings.payScales.details.sections.apprenticeIncome": "Lehrlingseinkommen",
  "settings.payScales.details.sections.info": "Kollektivvertrag",
  "settings.payScales.details.sections.salaryTables": "Mindestgehaltstabellen",
  "settings.payScales.details.table.amount": "Betrag",
  "settings.payScales.details.table.emptyCell": "—",
  "settings.payScales.details.table.level": "Stufe",
  "settings.payScales.details.tablesEmpty": "Für diesen Kollektivvertrag sind noch keine Gehaltsgruppen oder Stufen konfiguriert.",
  "settings.payScales.details.tablesLoading": "Gehaltstabellen werden geladen…",
  "settings.payScales.details.validFrom": "Gültig ab",
  "settings.payScales.details.validTo": "Gültig bis",
  "settings.payScales.details.weeklyWorkHours": "Regelarbeitszeit Woche",
  "settings.payScales.form.createTitle": "Kollektivvertrag erstellen",
  "settings.payScales.form.editTitle": "Kollektivvertrag bearbeiten",
  "settings.payScales.form.fields.code": "Kurzbezeichnung",
  "settings.payScales.form.fields.dailyWorkHours": "Regelarbeitszeit Tag",
  "settings.payScales.form.fields.monthlyWorkHours": "Regelarbeitszeit Monat",
  "settings.payScales.form.fields.name": "Bezeichnung",
  "settings.payScales.form.fields.validFrom": "Gültig ab",
  "settings.payScales.form.fields.validTo": "Gültig bis",
  "settings.payScales.form.fields.weeklyWorkHours": "Regelarbeitszeit Woche",
  "settings.payScales.form.loading": "Kollektivvertrag wird geladen…",
  "settings.payScales.form.validation.codeMaxLength": "Kurzbezeichnung ist zu lang",
  "settings.payScales.form.validation.codeRequired": "Kurzbezeichnung ist erforderlich",
  "settings.payScales.form.validation.nameMaxLength": "Bezeichnung ist zu lang",
  "settings.payScales.form.validation.nameRequired": "Bezeichnung ist erforderlich",
  "settings.payScales.form.validation.validFromRequired": "„Gültig ab\" ist erforderlich",
  "settings.payScales.list.placeholderDescription": "Wählen Sie einen Kollektivvertrag aus der Tabelle, um Details anzuzeigen.",
  "settings.payScales.list.placeholderTitle": "Kollektivverträge",
  "settings.payScales.title": "Kollektivverträge",
  "settings.profile.fields.company": "Unternehmen",
  "settings.profile.fields.createdAt": "Erstellt am",
  "settings.profile.fields.email": "E-Mail",
  "settings.profile.fields.personId": "Personen-ID",
  "settings.profile.fields.phone": "Telefon",
  "settings.profile.fields.type": "Typ",
  "settings.profile.loading": "Profil wird geladen …",
  "settings.profile.noOrganization.description": "Wählen Sie eine Organisation im Kontext-Switcher, um Ihr Profil in dieser Organisation anzuzeigen.",
  "settings.profile.noOrganization.title": "Keine Organisation ausgewählt",
  "settings.profile.noPerson.description": "Für diese Organisation ist keine Person mit Ihrem Benutzerkonto verknüpft.",
  "settings.profile.noPerson.title": "Keine Person in dieser Organisation",
  "settings.profile.sections.contact": "Kontakt",
  "settings.profile.sections.meta": "Metadaten",
  "settings.profile.title": "Profil",
  "settings.roles.actions.cancel": "Abbrechen",
  "settings.roles.actions.create": "Erstellen",
  "settings.roles.actions.edit": "Bearbeiten",
  "settings.roles.actions.save": "Speichern",
  "settings.roles.actions.saving": "Wird gespeichert…",
  "settings.roles.columns.description": "Description",
  "settings.roles.columns.name": "Name",
  "settings.roles.description": "Manage organization roles and permissions",
  "settings.roles.form.createTitle": "Rolle anlegen",
  "settings.roles.form.editTitle": "Rolle bearbeiten",
  "settings.roles.form.fields.description": "Beschreibung",
  "settings.roles.form.fields.name": "Name",
  "settings.roles.form.loading": "Rolle wird geladen…",
  "settings.roles.form.section.info": "Rolleninformationen",
  "settings.roles.form.validation.descriptionMaxLength": "Beschreibung ist zu lang",
  "settings.roles.form.validation.nameMaxLength": "Name ist zu lang",
  "settings.roles.form.validation.nameRequired": "Name ist erforderlich",
  "settings.roles.list.placeholderDescription": "Wählen Sie eine Rolle aus der Tabelle, um Details in der Schublade anzuzeigen.",
  "settings.roles.list.placeholderTitle": "Rollen",
  "settings.roles.permissionMatrix": "Permission Matrix",
  "settings.roles.permissionMatrixDescription": "View the permissions granted to this role across different scopes and entities",
  "settings.roles.title": "Roles",
  "settings.textCatalog.actions.backToCatalog": "Zurück zu Katalogeinträgen",
  "settings.textCatalog.actions.create": "Eintrag erstellen",
  "settings.textCatalog.actions.edit": "Bearbeiten",
  "settings.textCatalog.actions.manageLanguages": "Sprachen verwalten",
  "settings.textCatalog.actions.manageTypes": "Katalogtypen verwalten",
  "settings.textCatalog.actions.saving": "Speichern…",
  "settings.textCatalog.columns.catalogKey": "Schlüssel",
  "settings.textCatalog.columns.catalogType": "Typ",
  "settings.textCatalog.columns.name": "Bezeichnung",
  "settings.textCatalog.columns.scope": "Geltungsbereich",
  "settings.textCatalog.description": "Dynamische Katalogeinträge und deren Übersetzungen verwalten.",
  "settings.textCatalog.details.loading": "Katalogeintrag wird geladen…",
  "settings.textCatalog.details.sections.info": "Eintragsdetails",
  "settings.textCatalog.filters.catalogType": "Katalogtyp",
  "settings.textCatalog.filters.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.form.createTitle": "Katalogeintrag erstellen",
  "settings.textCatalog.form.editTitle": "Katalogeintrag bearbeiten",
  "settings.textCatalog.form.fields.catalogKey": "Schlüssel",
  "settings.textCatalog.form.fields.catalogKeyPlaceholder": "female",
  "settings.textCatalog.form.fields.catalogType": "Typ",
  "settings.textCatalog.form.fields.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.form.fields.countryCode": "Land",
  "settings.textCatalog.form.fields.countryCodePlaceholder": "Land wählen",
  "settings.textCatalog.form.fields.noActiveLanguages": "Keine aktiven Sprachen konfiguriert.",
  "settings.textCatalog.form.fields.organization": "Organisation",
  "settings.textCatalog.form.fields.organizationPlaceholder": "Organisation wählen",
  "settings.textCatalog.form.fields.organizationUnit": "Organisationseinheit",
  "settings.textCatalog.form.fields.organizationUnitPlaceholder": "Organisationseinheit wählen",
  "settings.textCatalog.form.fields.scope": "Geltungsbereich",
  "settings.textCatalog.form.fields.scopePlaceholder": "Geltungsbereich wählen",
  "settings.textCatalog.form.fields.translationPlaceholder": "Übersetzung für {{language}}",
  "settings.textCatalog.form.fields.translations": "Übersetzungen",
  "settings.textCatalog.form.loading": "Katalogeintrag wird geladen…",
  "settings.textCatalog.form.scope.country": "Land",
  "settings.textCatalog.form.scope.global": "Global",
  "settings.textCatalog.form.scope.organizationUnit": "Organisationseinheit",
  "settings.textCatalog.form.section.identity": "Identität",
  "settings.textCatalog.form.section.scope": "Geltungsbereich",
  "settings.textCatalog.form.validation.catalogKeyMaxLength": "Schlüssel ist zu lang",
  "settings.textCatalog.form.validation.catalogKeyPattern": "Schlüssel darf nur Buchstaben, Zahlen, Unterstriche und Bindestriche enthalten",
  "settings.textCatalog.form.validation.catalogKeyRequired": "Schlüssel ist erforderlich",
  "settings.textCatalog.form.validation.catalogTypeMaxLength": "Typ ist zu lang",
  "settings.textCatalog.form.validation.catalogTypePattern": "Typ muss aus Großbuchstaben, Zahlen und Unterstrichen bestehen",
  "settings.textCatalog.form.validation.catalogTypeRequired": "Typ ist erforderlich",
  "settings.textCatalog.form.validation.scopeRequired": "Geltungsbereich ist erforderlich",
  "settings.textCatalog.languages.actions.create": "Sprache erstellen",
  "settings.textCatalog.languages.actions.edit": "Bearbeiten",
  "settings.textCatalog.languages.actions.saving": "Speichern…",
  "settings.textCatalog.languages.columns.code": "Code",
  "settings.textCatalog.languages.columns.isActive": "Aktiv",
  "settings.textCatalog.languages.columns.name": "Name",
  "settings.textCatalog.languages.columns.sortOrder": "Sortierung",
  "settings.textCatalog.languages.description": "Verfügbare Sprachen für Katalogübersetzungen verwalten.",
  "settings.textCatalog.languages.details.loading": "Sprache wird geladen…",
  "settings.textCatalog.languages.details.sections.info": "Sprachdetails",
  "settings.textCatalog.languages.form.createTitle": "Sprache erstellen",
  "settings.textCatalog.languages.form.editTitle": "Sprache bearbeiten",
  "settings.textCatalog.languages.form.fields.code": "Code",
  "settings.textCatalog.languages.form.fields.codePlaceholder": "en",
  "settings.textCatalog.languages.form.fields.isActive": "Aktiv",
  "settings.textCatalog.languages.form.fields.name": "Name",
  "settings.textCatalog.languages.form.fields.namePlaceholder": "English",
  "settings.textCatalog.languages.form.fields.sortOrder": "Sortierung",
  "settings.textCatalog.languages.form.loading": "Sprache wird geladen…",
  "settings.textCatalog.languages.form.section.info": "Sprache",
  "settings.textCatalog.languages.form.validation.codeMaxLength": "Code ist zu lang",
  "settings.textCatalog.languages.form.validation.codeMinLength": "Code muss mindestens 2 Zeichen haben",
  "settings.textCatalog.languages.form.validation.codePattern": "Code darf nur Buchstaben, Zahlen, Unterstriche und Bindestriche enthalten",
  "settings.textCatalog.languages.form.validation.codeRequired": "Code ist erforderlich",
  "settings.textCatalog.languages.form.validation.nameMaxLength": "Name ist zu lang",
  "settings.textCatalog.languages.form.validation.nameRequired": "Name ist erforderlich",
  "settings.textCatalog.languages.list.placeholderDescription": "Wählen Sie eine Sprache aus der Tabelle, um Details in der Schublade anzuzeigen.",
  "settings.textCatalog.languages.list.placeholderTitle": "Sprachen",
  "settings.textCatalog.languages.title": "Sprachen",
  "settings.textCatalog.list.placeholderDescription": "Wählen Sie einen Katalogeintrag aus der Tabelle, um Details in der Schublade anzuzeigen.",
  "settings.textCatalog.list.placeholderTitle": "Katalogeinträge",
  "settings.textCatalog.title": "Textkatalog",
  "settings.textCatalog.types.actions.create": "Katalogtyp anlegen",
  "settings.textCatalog.types.actions.edit": "Bearbeiten",
  "settings.textCatalog.types.actions.saving": "Wird gespeichert…",
  "settings.textCatalog.types.columns.catalogType": "Typ",
  "settings.textCatalog.types.columns.permissionAction": "Berechtigungsaktion",
  "settings.textCatalog.types.columns.permissionEntity": "Berechtigungsentität",
  "settings.textCatalog.types.description": "Katalogtypen anlegen und festlegen, welche Berechtigung für Abfragen im Kontext einer Organisationseinheit nötig ist.",
  "settings.textCatalog.types.details.loading": "Katalogtyp wird geladen…",
  "settings.textCatalog.types.details.sections.info": "Details zum Typ",
  "settings.textCatalog.types.form.createTitle": "Katalogtyp anlegen",
  "settings.textCatalog.types.form.editTitle": "Katalogtyp bearbeiten",
  "settings.textCatalog.types.form.fields.catalogType": "Typcode",
  "settings.textCatalog.types.form.fields.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.types.form.fields.organizations": "Organisationen",
  "settings.textCatalog.types.form.fields.organizationsPlaceholder": "Organisationen wählen",
  "settings.textCatalog.types.form.fields.permissionAction": "Berechtigungsaktion",
  "settings.textCatalog.types.form.fields.permissionActionPlaceholder": "Aktion wählen",
  "settings.textCatalog.types.form.fields.permissionEntity": "Berechtigungsbereich",
  "settings.textCatalog.types.form.fields.permissionEntityPlaceholder": "Bereich wählen",
  "settings.textCatalog.types.form.fields.permissionNone": "Keine",
  "settings.textCatalog.types.form.fields.scopeMode": "Geltungsbereich",
  "settings.textCatalog.types.form.fields.scopeModePlaceholder": "Geltungsbereich wählen",
  "settings.textCatalog.types.form.loading": "Katalogtyp wird geladen…",
  "settings.textCatalog.types.form.permissionHint": "Ist sie gesetzt, muss der Aufrufer diese Berechtigung auf der angefragten Organisationseinheit haben, um nicht globale Einträge zu lesen.",
  "settings.textCatalog.types.form.section.identity": "Kennung",
  "settings.textCatalog.types.form.section.organizations": "Organisationszugriff",
  "settings.textCatalog.types.form.section.permission": "Berechtigung im Einheitenkontext",
  "settings.textCatalog.types.form.validation.catalogTypeMaxLength": "Typ ist zu lang",
  "settings.textCatalog.types.form.validation.catalogTypePattern": "Typ muss aus Großbuchstaben, Zahlen und Unterstrichen bestehen",
  "settings.textCatalog.types.form.validation.catalogTypeRequired": "Typ ist erforderlich",
  "settings.textCatalog.types.form.validation.scopeModeRequired": "Geltungsbereich ist erforderlich",
  "settings.textCatalog.types.list.placeholderDescription": "Wählen Sie einen Katalogtyp in der Tabelle, um die Details anzuzeigen.",
  "settings.textCatalog.types.list.placeholderTitle": "Katalogtypen",
  "settings.textCatalog.types.scopeMode.global": "Global",
  "settings.textCatalog.types.scopeMode.organization": "Organisation",
  "settings.textCatalog.types.title": "Katalogtypen",
  "settings.textCatalog.values.no": "Nein",
  "settings.textCatalog.values.yes": "Ja",
  "skill.entity.group.persons": "Personen",
  "skill.entity.skill": "Fähigkeiten",
  "skills.actions.create": "+ Fähigkeit",
  "skills.actions.edit": "Bearbeiten",
  "skills.actions.saving": "Speichert …",
  "skills.columns.code": "Kürzel",
  "skills.columns.description": "Beschreibung",
  "skills.columns.name": "Bezeichnung",
  "skills.description": "Die Fähigkeiten dieser Organisation. Welche Stufe jemand hat, wird bei der Person gesetzt.",
  "skills.details.code": "Kürzel",
  "skills.details.description": "Beschreibung",
  "skills.details.name": "Bezeichnung",
  "skills.details.sections.info": "Fähigkeit",
  "skills.form.createTitle": "Neue Fähigkeit",
  "skills.form.editTitle": "Fähigkeit bearbeiten",
  "skills.form.fields.code": "Kürzel",
  "skills.form.fields.codeHint": "Kurz und eindeutig. Darauf greifen später Anforderungen und Importe zu.",
  "skills.form.fields.codePlaceholder": "z. B. STAPLER",
  "skills.form.fields.description": "Beschreibung (optional)",
  "skills.form.fields.name": "Bezeichnung",
  "skills.form.fields.namePlaceholder": "z. B. Staplerschein",
  "skills.form.loading": "Lädt …",
  "skills.form.validation.codeMaxLength": "Das Kürzel darf höchstens 50 Zeichen lang sein.",
  "skills.form.validation.codeRequired": "Bitte ein Kürzel angeben.",
  "skills.form.validation.descriptionMaxLength": "Die Beschreibung darf höchstens 1000 Zeichen lang sein.",
  "skills.form.validation.nameMaxLength": "Die Bezeichnung darf höchstens 255 Zeichen lang sein.",
  "skills.form.validation.nameRequired": "Bitte eine Bezeichnung angeben.",
  "skills.level.ASSISTED": "Unter Anleitung",
  "skills.level.EXPERIENCED": "Routiniert",
  "skills.level.INDEPENDENT": "Selbstständig",
  "skills.level.INSTRUCTOR": "Kann anleiten",
  "skills.level.LEARNING": "In Einarbeitung",
  "skills.list.placeholderDescription": "Eine Zeile anklicken, um die Fähigkeit anzusehen.",
  "skills.list.placeholderTitle": "Keine Fähigkeit ausgewählt",
  "skills.person.add.level": "Stufe",
  "skills.person.add.skill": "Fähigkeit",
  "skills.person.add.skillPlaceholder": "Fähigkeit wählen",
  "skills.person.add.submit": "Hinzufügen",
  "skills.person.catalogueError": "Der Fähigkeitskatalog konnte nicht geladen werden.",
  "skills.person.description": "Was diese Person kann und auf welcher Stufe. Die Fähigkeiten selbst werden unter Personen → Fähigkeiten gepflegt.",
  "skills.person.empty": "Für diese Person ist noch keine Fähigkeit hinterlegt.",
  "skills.person.loadError": "Die Fähigkeiten dieser Person konnten nicht geladen werden.",
  "skills.person.loading": "Lädt …",
  "skills.person.noOrganization": "Diese Person gehört zu keiner Organisation. Fähigkeiten werden je Organisation gepflegt.",
  "skills.person.nothingLeft": "Alle Fähigkeiten des Katalogs sind bereits hinterlegt.",
  "skills.person.remove.confirm": "„{{name}}“ wird bei dieser Person entfernt. Die Fähigkeit selbst bleibt im Katalog.",
  "skills.person.title": "Fähigkeiten",
  "skills.requirements.add.hint": "Die Auswahl fordert die Fähigkeit sofort mit „{{level}}“. Die Stufe änderst du danach in ihrer Zeile.",
  "skills.requirements.add.skill": "Fähigkeit fordern",
  "skills.requirements.add.skillPlaceholder": "Fähigkeit wählen",
  "skills.requirements.atLeast": "mindestens",
  "skills.requirements.catalogueError": "Der Fähigkeitskatalog konnte nicht geladen werden.",
  "skills.requirements.empty": "Es ist noch keine Fähigkeit gefordert.",
  "skills.requirements.loadError": "Die geforderten Fähigkeiten konnten nicht geladen werden.",
  "skills.requirements.loading": "Lädt …",
  "skills.requirements.nothingLeft": "Alle Fähigkeiten des Katalogs sind bereits gefordert.",
  "skills.requirements.positionDescription": "Was diese Stelle verlangt. Die Stufe ist ein Mindestwert — wer darüber liegt, erfüllt sie auch.",
  "skills.requirements.remove.confirm": "„{{name}}“ wird hier nicht mehr gefordert. Die Fähigkeit selbst bleibt im Katalog.",
  "skills.requirements.stationDescription": "Was diese Station verlangt. Die Stufe ist ein Mindestwert — wer darüber liegt, erfüllt sie auch.",
  "skills.requirements.title": "Geforderte Fähigkeiten",
  "skills.title": "Fähigkeiten",
  "table.columns.save": "Speichern",
  "table.columns.showAll": "Alle anzeigen",
  "table.columns.title": "Spalten",
  "textCatalog.select.empty": "Keine Katalogeinträge verfügbar",
  "textCatalog.select.error": "Katalogeinträge konnten nicht geladen werden",
  "textCatalog.select.loading": "Katalogeinträge werden geladen…",
  "timeAccounts.header.noPerson": "Kein Dienstverhältnis gewählt",
  "timeAccounts.header.personnelNumber": "Pers.-Nr. {{number}}",
  "timeAccounts.header.period": "Zeitraum",
  "timeAccounts.header.previousMonth": "Vorheriger Monat",
  "timeAccounts.header.nextMonth": "Nächster Monat",
  "timeAccounts.header.previousYear": "Vorheriges Jahr",
  "timeAccounts.header.nextYear": "Nächstes Jahr",
  "timeAccounts.header.workSchedule": "Zeitmodell",
  "timeAccounts.employment": "Dienstverhältnis",
  "timeAccounts.errors.loadFailed": "Die Salden konnten nicht geladen werden.",
  "timeAccounts.fromEntries": "aus {{count}} Buchungen",
  "timeAccounts.grid.date": "Datum",
  "timeAccounts.grid.columns": "Spalten",
  "timeAccounts.grid.show": "Anzeigen",
  "timeAccounts.grid.timeType": "Zeitart",
  "timeAccounts.grid.allTimeTypes": "Alle Zeitarten",
  "timeAccounts.grid.timeTypes": "Zeitarten",
  "timeAccounts.grid.filters.all": "Alle Tage",
  "timeAccounts.grid.filters.booked": "Nur Tage mit Buchungen",
  "timeAccounts.grid.filters.deviating": "Nur Abweichungen vom Soll",
  "timeAccounts.grid.dayCount": "{{shown}} von {{total}} Tagen",
  "timeAccounts.summary.balanceAfter": "Saldo nach Buchung",
  "timeAccounts.grid.weekday": "Tag",
  "timeAccounts.grid.spans": "Berechnete Buchungen",
  "timeAccounts.grid.kind": "Zeitart",
  "timeAccounts.grid.break": "Pause",
  "timeAccounts.grid.deduction": "Abzug",
  "timeAccounts.grid.note": "Bemerkung",
  "timeAccounts.grid.worked": "Arbeitszeit Ist",
  "timeAccounts.grid.target": "Sollzeit",
  "timeAccounts.grid.overtime": "Üstd. Tag",
  "timeAccounts.grid.toggleDay": "Tag auf- und zuklappen",
  "timeAccounts.grid.loadFailed": "Das Monatsjournal konnte nicht geladen werden.",
  "timeAccounts.ledgerHint": "Summiert aus dem Buchungsjournal bis zum Monatsende, nicht aus einer gespeicherten Momentaufnahme.",
  "timeAccounts.noBalances": "Für dieses Dienstverhältnis wurde bis zum Monatsende nichts gebucht.",
  "timeAccounts.noEmployments": "Diese Einheit hat keine Dienstverhältnisse.",
  "timeAccounts.organizationUnit": "Organisationseinheit",
  "timeAccounts.summary.corrections": "Besondere Buchungen und Korrekturen",
  "timeAccounts.summary.correctionsHint": "Alles, was nicht die Bewertung des Tages selbst ist — von Hand gebucht, aus einem Abschluss oder storniert.",
  "timeAccounts.summary.showHiddenAccounts": "Auch ausgeblendete Konten zeigen ({{count}})",
  "timeAccounts.summary.noCorrections": "In diesem Monat wurde nichts von Hand gebucht.",
  "timeAccounts.summary.balances": "Zeitkonto-Salden zum Monatsende",
  "timeAccounts.summary.account": "Konto",
  "timeAccounts.summary.amount": "Betrag",
  "timeAccounts.summary.origin": "Herkunft",
  "timeAccounts.summary.monthChange": "Monatsbewegung",
  "timeAccounts.summary.balance": "Saldo",
  "timeAccounts.summary.unit": "Einheit",
  "timeAccounts.summary.origins.MANUAL": "Von Hand",
  "timeAccounts.summary.origins.CLOSING": "Abschluss",
  "timeAccounts.summary.origins.INITIALIZE": "Auf Wert gesetzt",
  "timeAccounts.unit.counter": "",
  "timeAccounts.unit.days": "Tage",
  "timeAccounts.unit.minutes": "Std.",
  "timeAccounts.unit.number": "",
  "timeManagement.accounts.actions.create": "Konto anlegen",
  "timeManagement.accounts.delete.confirm": "Möchten Sie dieses Konto wirklich löschen?",
  "timeManagement.accounts.displayFormat.DAYS": "Tage",
  "timeManagement.accounts.displayFormat.DECIMAL_HOURS": "Dezimalstunden",
  "timeManagement.accounts.displayFormat.HH_MM": "Stunden:Minuten",
  "timeManagement.accounts.errors.loadFailed": "Konten konnten nicht geladen werden.",
  "timeManagement.accounts.form.createTitle": "Neues Konto",
  "timeManagement.accounts.form.editTitle": "Konto bearbeiten",
  "timeManagement.accounts.form.fields.accountKind": "Kontoart",
  "timeManagement.accounts.form.fields.allowsManualBooking": "Manuelle Buchung erlaubt",
  "timeManagement.accounts.form.fields.allowsNegativeBalance": "Negativer Saldo erlaubt",
  "timeManagement.accounts.form.fields.shownInSpecialBookings": "Unter „Besondere Buchungen“ anzeigen",
  "timeManagement.accounts.form.fields.code": "Code",
  "timeManagement.accounts.form.fields.codePlaceholder": "z. B. UEBERSTUNDEN_50",
  "timeManagement.accounts.form.fields.displayFormat": "Anzeigeformat",
  "timeManagement.accounts.form.fields.displayFormatHelp": "Reine Darstellung — ändert nicht, wie der Saldo gespeichert wird.",
  "timeManagement.accounts.form.fields.displayFormatNone": "Kein Format",
  "timeManagement.accounts.form.fields.name": "Bezeichnung",
  "timeManagement.accounts.form.fields.negativeLimit": "Untergrenze (optional)",
  "timeManagement.accounts.form.fields.valueType": "Werttyp",
  "timeManagement.accounts.form.overrideTitle": "Konto überschreiben",
  "timeManagement.accounts.form.validation.codeMaxLength": "Code ist zu lang.",
  "timeManagement.accounts.form.validation.codeRequired": "Code ist erforderlich.",
  "timeManagement.accounts.form.validation.nameMaxLength": "Bezeichnung ist zu lang.",
  "timeManagement.accounts.form.validation.nameRequired": "Bezeichnung ist erforderlich.",
  "timeManagement.accounts.form.validation.validFromRequired": "Gültig ab ist erforderlich.",
  "timeManagement.accounts.kind.COUNTER": "Zähler",
  "timeManagement.accounts.kind.ENTITLEMENT": "Anspruch",
  "timeManagement.accounts.kind.TIME": "Zeitkonto",
  "timeManagement.accounts.list.empty": "Noch keine Konten vorhanden.",
  "timeManagement.accounts.list.manualBooking": "manuell buchbar",
  "timeManagement.accounts.list.hiddenFromSpecialBookings": "nicht unter Besondere Buchungen",
  "timeManagement.accounts.list.noNegative": "kein Negativsaldo",
  "timeManagement.accounts.valueType.COUNTER": "Zähler",
  "timeManagement.accounts.valueType.DAYS": "Tage",
  "timeManagement.accounts.valueType.MINUTES": "Minuten",
  "timeManagement.accounts.valueType.NUMBER": "Zahl",
  "timeManagement.bookingTypes.actions.create": "Buchungsart anlegen",
  "timeManagement.bookingTypes.delete.confirm": "Möchten Sie diese Buchungsart wirklich löschen?",
  "timeManagement.bookingTypes.directionHint.END": "Ende",
  "timeManagement.bookingTypes.directionHint.NEUTRAL": "Neutral",
  "timeManagement.bookingTypes.directionHint.START": "Beginn",
  "timeManagement.bookingTypes.errors.loadFailed": "Buchungsarten konnten nicht geladen werden.",
  "timeManagement.bookingTypes.form.createTitle": "Neue Buchungsart",
  "timeManagement.bookingTypes.form.editTitle": "Buchungsart bearbeiten",
  "timeManagement.bookingTypes.form.fields.code": "Code",
  "timeManagement.bookingTypes.form.fields.codePlaceholder": "z. B. KOMMEN",
  "timeManagement.bookingTypes.form.fields.directionHint": "Richtung (nur Anzeige)",
  "timeManagement.bookingTypes.form.fields.directionHintHelp": "Nur ein Anzeigehinweis — die tatsächliche Paarung von Beginn und Ende entscheidet das Regelwerk.",
  "timeManagement.bookingTypes.form.fields.directionHintNone": "Kein Hinweis",
  "timeManagement.bookingTypes.form.fields.isRealBooking": "Echte Buchung (kein Systemmarker)",
  "timeManagement.bookingTypes.form.fields.name": "Bezeichnung",
  "timeManagement.bookingTypes.form.overrideTitle": "Buchungsart überschreiben",
  "timeManagement.bookingTypes.form.validation.codeMaxLength": "Code ist zu lang.",
  "timeManagement.bookingTypes.form.validation.codeRequired": "Code ist erforderlich.",
  "timeManagement.bookingTypes.form.validation.nameMaxLength": "Bezeichnung ist zu lang.",
  "timeManagement.bookingTypes.form.validation.nameRequired": "Bezeichnung ist erforderlich.",
  "timeManagement.bookingTypes.form.validation.validFromRequired": "Gültig ab ist erforderlich.",
  "timeManagement.bookingTypes.list.empty": "Noch keine Buchungsarten vorhanden.",
  "timeManagement.bookingTypes.list.systemMarker": "Systemmarker",
  "timeManagement.common.inheritedFrom": "geerbt von {{unit}}",
  "timeManagement.common.overridden": "überschrieben",
  "timeManagement.common.override": "Hier überschreiben",
  "timeManagement.common.restore": "Lokale Fassung entfernen (erbt wieder)",
  "timeManagement.common.saving": "Speichern …",
  "timeManagement.common.validFrom": "Gültig ab",
  "timeManagement.common.validTo": "Gültig bis",
  "timeManagement.common.validUntil": "bis {{date}}",
  "timeManagement.dayPrograms.actions.create": "Tagesprogramm anlegen",
  "timeManagement.dayPrograms.delete.confirm": "Dieses Tagesprogramm löschen?",
  "timeManagement.dayPrograms.errors.loadFailed": "Die Tagesprogramme konnten nicht geladen werden.",
  "timeManagement.dayPrograms.form.coreTime.add": "Kernzeit hinzufügen",
  "timeManagement.dayPrograms.form.coreTime.empty": "Für diesen Tag ist keine Kernzeit festgelegt.",
  "timeManagement.dayPrograms.form.coreTime.endsNextDay": "endet am Folgetag",
  "timeManagement.dayPrograms.form.coreTime.from": "von",
  "timeManagement.dayPrograms.form.coreTime.hint": "Das Zeitfenster, in dem Anwesenheit erwartet wird. Gilt für jeden Wochentag, der dieses Tagesprogramm verwendet.",
  "timeManagement.dayPrograms.form.coreTime.problem.incomplete": "Bitte Beginn und Ende der Kernzeit angeben.",
  "timeManagement.dayPrograms.form.coreTime.problem.notForward": "Die Kernzeit muss nach ihrem Beginn enden.",
  "timeManagement.dayPrograms.form.coreTime.problem.overlap": "Zwei Kernzeiten dürfen dieselbe Minute nicht abdecken. Eine darf dort beginnen, wo die andere endet.",
  "timeManagement.dayPrograms.form.coreTime.remove": "Kernzeit entfernen",
  "timeManagement.dayPrograms.form.coreTime.title": "Kernzeit",
  "timeManagement.dayPrograms.form.coreTime.to": "bis",
  "timeManagement.dayPrograms.form.createTitle": "Neues Tagesprogramm",
  "timeManagement.dayPrograms.form.editTitle": "Tagesprogramm bearbeiten",
  "timeManagement.dayPrograms.form.fields.code": "Code",
  "timeManagement.dayPrograms.form.fields.codePlaceholder": "NORMAL",
  "timeManagement.dayPrograms.form.fields.name": "Bezeichnung",
  "timeManagement.dayPrograms.form.fields.targetMinutes": "Sollminuten",
  "timeManagement.dayPrograms.form.fields.targetMinutesHint": "Leer lassen, um die Intervalle zu summieren.",
  "timeManagement.dayPrograms.form.fields.validFrom": "Gültig ab",
  "timeManagement.dayPrograms.form.fields.validTo": "Gültig bis",
  "timeManagement.dayPrograms.form.intervals.add": "Intervall hinzufügen",
  "timeManagement.dayPrograms.form.intervals.chooseKind": "Bitte wählen…",
  "timeManagement.dayPrograms.form.intervals.empty": "Noch keine Intervalle. Ohne sie hat der Tag keinen geplanten Verlauf.",
  "timeManagement.dayPrograms.form.intervals.end": "Bis",
  "timeManagement.dayPrograms.form.intervals.endsNextDay": "Endet am Folgetag",
  "timeManagement.dayPrograms.form.intervals.errors.endBeforeStart": "Das Ende liegt nicht nach dem Beginn. Für eine Nachtschicht bitte „Endet am Folgetag\" ankreuzen.",
  "timeManagement.dayPrograms.form.intervals.errors.overlaps": "Dieses Intervall überschneidet sich mit einem früheren. Zwei Intervalle desselben Tagesprogramms dürfen dieselbe Minute nicht zweimal abdecken — eines darf aber genau dort enden, wo das nächste beginnt.",
  "timeManagement.dayPrograms.form.intervals.kind": "Art",
  "timeManagement.dayPrograms.form.intervals.moveDown": "Nach unten",
  "timeManagement.dayPrograms.form.intervals.moveUp": "Nach oben",
  "timeManagement.dayPrograms.form.intervals.remove": "Entfernen",
  "timeManagement.dayPrograms.form.intervals.spans": "dauert {{minutes}} Min.",
  "timeManagement.dayPrograms.form.intervals.start": "Von",
  "timeManagement.dayPrograms.form.intervals.targetMinutes": "Zählt als (Min.)",
  "timeManagement.dayPrograms.form.intervals.title": "Intervalle",
  "timeManagement.dayPrograms.form.overrideTitle": "Tagesprogramm überschreiben",
  "timeManagement.dayPrograms.form.saving": "Wird gespeichert…",
  "timeManagement.dayPrograms.form.validation.codeMaxLength": "Der Code darf höchstens 50 Zeichen haben.",
  "timeManagement.dayPrograms.form.validation.codeRequired": "Bitte einen Code eingeben.",
  "timeManagement.dayPrograms.form.validation.nameMaxLength": "Die Bezeichnung darf höchstens 255 Zeichen haben.",
  "timeManagement.dayPrograms.form.validation.nameRequired": "Bitte eine Bezeichnung eingeben.",
  "timeManagement.dayPrograms.form.validation.validFromRequired": "Bitte einen Gültigkeitsbeginn eingeben.",
  "timeManagement.dayPrograms.list.empty": "Für diese Einheit gibt es noch keine Tagesprogramme.",
  "timeManagement.dayPrograms.list.target": "Soll {{minutes}} Min.",
  "timeManagement.dayPrograms.list.targetFromIntervals": "Soll aus den Intervallen",
  "timeManagement.publicHolidays.actions.create": "Feiertag anlegen",
  "timeManagement.publicHolidays.calendar.empty": "In diesem Jahr fällt kein Feiertag auf diese OE.",
  "timeManagement.publicHolidays.calendar.title": "Kalender {{year}}",
  "timeManagement.publicHolidays.calendar.previousYear": "Vorjahr",
  "timeManagement.publicHolidays.calendar.nextYear": "Folgejahr",
  "timeManagement.publicHolidays.delete.confirm": "Diesen Feiertag wirklich löschen?",
  "timeManagement.publicHolidays.errors.loadFailed": "Die Feiertage konnten nicht geladen werden.",
  "timeManagement.publicHolidays.form.createTitle": "Feiertag anlegen",
  "timeManagement.publicHolidays.form.editTitle": "Feiertag bearbeiten",
  "timeManagement.publicHolidays.form.fields.code": "Code",
  "timeManagement.publicHolidays.form.fields.countries": "Gilt in diesen Ländern",
  "timeManagement.publicHolidays.form.fields.dayOfMonth": "Tag",
  "timeManagement.publicHolidays.form.fields.kind": "Datumsbestimmung",
  "timeManagement.publicHolidays.form.fields.monthOfYear": "Monat",
  "timeManagement.publicHolidays.form.fields.name": "Bezeichnung",
  "timeManagement.publicHolidays.form.fields.offsetDays": "Tage ab Ostersonntag",
  "timeManagement.publicHolidays.form.fields.singleDate": "Datum",
  "timeManagement.publicHolidays.form.fields.validFrom": "Gültig ab",
  "timeManagement.publicHolidays.form.fields.validTo": "Gültig bis",
  "timeManagement.publicHolidays.form.hints.countries": "Nur Länder, die im Organigramm vorkommen. Halbtags heißt halbes Soll, ohne Lage.",
  "timeManagement.publicHolidays.form.hints.noCountries": "Im Organigramm ist noch kein Land gesetzt. Trage eines an der Firma oder an der Wurzel ein.",
  "timeManagement.publicHolidays.form.hints.offsetDays": "Negativ läuft vor Ostern: Karfreitag −2, Ostermontag 1, Fronleichnam 60.",
  "timeManagement.publicHolidays.form.hints.singleDate": "Das eine Datum, an dem dieser Feiertag stattfindet. Er kehrt nicht wieder.",
  "timeManagement.publicHolidays.form.hints.validity": "Wann es den Feiertag gibt, nicht wann er fällt. Leer heißt unbefristet.",
  "timeManagement.publicHolidays.form.overrideTitle": "Feiertag überschreiben",
  "timeManagement.publicHolidays.form.validation.codeMaxLength": "Der Code darf höchstens 50 Zeichen haben.",
  "timeManagement.publicHolidays.form.validation.codeRequired": "Ein Code ist erforderlich.",
  "timeManagement.publicHolidays.form.validation.countryNone": "Bitte mindestens ein Land auswählen — sonst gilt der Feiertag nirgends.",
  "timeManagement.publicHolidays.form.validation.dateNeverOccurs": "Diesen Tag gibt es in keinem Jahr.",
  "timeManagement.publicHolidays.form.validation.dayOutOfRange": "Der Tag muß zwischen 1 und 31 liegen.",
  "timeManagement.publicHolidays.form.validation.easterNeedsOffset": "Ein von Ostern gerechneter Feiertag braucht einen Versatz.",
  "timeManagement.publicHolidays.form.validation.easterTakesNoDate": "Ein von Ostern gerechneter Feiertag hat kein festes Datum.",
  "timeManagement.publicHolidays.form.validation.fixedNeedsDate": "Ein Feiertag an einem festen Datum braucht Monat und Tag.",
  "timeManagement.publicHolidays.form.validation.fixedTakesNoOffset": "Ein Feiertag an einem festen Datum hat keinen Osterversatz.",
  "timeManagement.publicHolidays.form.validation.monthOutOfRange": "Der Monat muß zwischen 1 und 12 liegen.",
  "timeManagement.publicHolidays.form.validation.nameMaxLength": "Die Bezeichnung darf höchstens 255 Zeichen haben.",
  "timeManagement.publicHolidays.form.validation.nameRequired": "Eine Bezeichnung ist erforderlich.",
  "timeManagement.publicHolidays.form.validation.offsetOutOfRange": "Der Versatz ist zu groß für einen beweglichen Feiertag.",
  "timeManagement.publicHolidays.form.validation.recurringTakesNoSingleDate": "Ein wiederkehrender Feiertag trägt kein Einzeldatum.",
  "timeManagement.publicHolidays.form.validation.singleDateMalformed": "Das muss ein echter Tag sein, als JJJJ-MM-TT.",
  "timeManagement.publicHolidays.form.validation.singleNeedsDate": "Ein einmaliger Feiertag braucht sein Datum.",
  "timeManagement.publicHolidays.form.validation.singleTakesNoRule": "Ein einmaliger Feiertag trägt weder Monat und Tag noch einen Oster-Versatz.",
  "timeManagement.publicHolidays.form.validation.validFromRequired": "Ein Beginn der Gültigkeit ist erforderlich.",
  "timeManagement.publicHolidays.kinds.EASTER_OFFSET": "Von Ostern gerechnet",
  "timeManagement.publicHolidays.kinds.FIXED": "Festes Datum",
  "timeManagement.publicHolidays.kinds.SINGLE_DATE": "Einmalig",
  "timeManagement.publicHolidays.list.definitionsTitle": "Feiertage",
  "timeManagement.publicHolidays.tabs.calendar": "Kalender",
  "timeManagement.publicHolidays.tabs.list": "Feiertage",
  "timeManagement.publicHolidays.list.empty": "Für diese OE ist noch kein Feiertag hinterlegt.",
  "timeManagement.publicHolidays.observances.FULL": "Ganz",
  "timeManagement.publicHolidays.observances.HALF": "Halb",
  "timeManagement.timeTypes.actions.create": "Zeitart anlegen",
  "timeManagement.timeTypes.delete.confirm": "Möchten Sie diese Zeitart wirklich löschen?",
  "timeManagement.timeTypes.errors.loadFailed": "Zeitarten konnten nicht geladen werden.",
  "timeManagement.timeTypes.form.createTitle": "Neue Zeitart",
  "timeManagement.timeTypes.form.editTitle": "Zeitart bearbeiten",
  "timeManagement.timeTypes.form.fields.category": "Kategorie",
  "timeManagement.timeTypes.form.fields.categoryPlaceholder": "Bitte wählen …",
  "timeManagement.timeTypes.form.fields.code": "Code",
  "timeManagement.timeTypes.form.fields.displayOrder": "Anzeigereihenfolge (optional)",
  "timeManagement.timeTypes.form.fields.evaluationPriority": "Vorrang",
  "timeManagement.timeTypes.form.fields.evaluationPriorityHint": "Bei Überschneidung am selben Tag zieht die höhere Zahl. 0 bedeutet kein Vorrang.",
  "timeManagement.timeTypes.form.fields.name": "Bezeichnung",
  "timeManagement.timeTypes.form.fields.workTimeCreditMode": "Anrechnung auf Sollzeit",
  "timeManagement.timeTypes.form.fields.workTimeCreditModeHint": "Wie ein Segment dieser Zeitart auf die Sollzeit angerechnet wird.",
  "timeManagement.timeTypes.form.fields.workTimeCreditModePlaceholder": "Anrechnungsart wählen",
  "timeManagement.timeTypes.form.overrideTitle": "Zeitart überschreiben",
  "timeManagement.timeTypes.form.validation.categoryRequired": "Kategorie ist erforderlich.",
  "timeManagement.timeTypes.form.validation.codeMaxLength": "Code ist zu lang.",
  "timeManagement.timeTypes.form.validation.codeRequired": "Code ist erforderlich.",
  "timeManagement.timeTypes.form.validation.creditModeRequired": "Anrechnungsart ist erforderlich",
  "timeManagement.timeTypes.form.validation.nameMaxLength": "Bezeichnung ist zu lang.",
  "timeManagement.timeTypes.form.validation.nameRequired": "Bezeichnung ist erforderlich.",
  "timeManagement.timeTypes.form.validation.validFromRequired": "Gültig ab ist erforderlich.",
  "timeManagement.timeTypes.list.empty": "Noch keine Zeitarten vorhanden.",
  "timeManagement.timeTypes.list.priority": "Vorrang {{value}}",
  "timeManagement.workSchedules.actions.create": "Zeitmodell anlegen",
  "timeManagement.workSchedules.delete.confirm": "Dieses Zeitmodell löschen?",
  "timeManagement.workSchedules.errors.loadFailed": "Die Zeitmodelle konnten nicht geladen werden.",
  "timeManagement.workSchedules.form.coreTime.add": "+ Kernzeit",
  "timeManagement.workSchedules.form.coreTime.endsNextDay": "endet am Folgetag",
  "timeManagement.workSchedules.form.coreTime.from": "Kernzeit von",
  "timeManagement.workSchedules.form.coreTime.hint": "Optional je Wochentag: die Kernzeit, in der die Person anwesend sein soll.",
  "timeManagement.workSchedules.form.coreTime.problems.incomplete": "Eine Kernzeit braucht Beginn und Ende.",
  "timeManagement.workSchedules.form.coreTime.problems.notForward": "Die Kernzeit muß nach ihrem Beginn enden — über Mitternacht bitte „endet am Folgetag“ ankreuzen.",
  "timeManagement.workSchedules.form.coreTime.problems.overlap": "Zwei Kernzeiten desselben Tages überschneiden sich. Eine darf genau dort enden, wo die nächste beginnt.",
  "timeManagement.workSchedules.form.coreTime.remove": "Kernzeit entfernen",
  "timeManagement.workSchedules.form.coreTime.to": "bis",
  "timeManagement.workSchedules.form.createTitle": "Neues Zeitmodell",
  "timeManagement.workSchedules.form.editTitle": "Zeitmodell bearbeiten",
  "timeManagement.workSchedules.form.fields.code": "Code",
  "timeManagement.workSchedules.form.fields.codePlaceholder": "STANDARD",
  "timeManagement.workSchedules.form.fields.cycleWeeks": "Turnus (Wochen)",
  "timeManagement.workSchedules.form.fields.cycleWeeksHint": "1 bedeutet jede Woche gleich. Mehr Wochen ergeben ein rotierendes Muster.",
  "timeManagement.workSchedules.form.fields.name": "Bezeichnung",
  "timeManagement.workSchedules.form.fields.validFrom": "Gültig ab",
  "timeManagement.workSchedules.form.fields.validTo": "Gültig bis",
  "timeManagement.workSchedules.form.grid.dayOff": "— frei —",
  "timeManagement.workSchedules.form.grid.dayProgramsFailed": "Die Tagesprogramme konnten nicht geladen werden. Das Wochenmuster lässt sich erst befüllen, wenn das gelingt.",
  "timeManagement.workSchedules.form.grid.noDayPrograms": "Für diese Einheit gibt es noch kein Tagesprogramm — auch kein geerbtes. Tagesprogramme werden nach unten vererbt, nicht nach oben: eines in einer untergeordneten Einheit zählt hier nicht. Bitte zuerst eines in dieser oder einer übergeordneten Einheit anlegen.",
  "timeManagement.workSchedules.form.grid.title": "Wochenmuster",
  "timeManagement.workSchedules.form.grid.unreadableCycle": "Für das Muster einen Turnus zwischen 1 und 52 Wochen eingeben.",
  "timeManagement.workSchedules.form.grid.week": "Woche {{week}}",
  "timeManagement.workSchedules.form.overrideTitle": "Zeitmodell überschreiben",
  "timeManagement.workSchedules.form.problems.coreTime": "Mindestens eine Kernzeit ist unvollständig oder überschneidet sich — siehe Markierung am Wochentag.",
  "timeManagement.workSchedules.form.problems.cycleWeeks": "Der Turnus muß eine ganze Zahl zwischen 1 und 52 Wochen sein.",
  "timeManagement.workSchedules.form.problems.noDays": "Mindestens einem Wochentag ein Tagesprogramm zuweisen — sonst plant dieses Modell nichts.",
  "timeManagement.workSchedules.form.saving": "Wird gespeichert…",
  "timeManagement.workSchedules.form.validation.codeMaxLength": "Der Code darf höchstens 50 Zeichen haben.",
  "timeManagement.workSchedules.form.validation.codeRequired": "Bitte einen Code eingeben.",
  "timeManagement.workSchedules.form.validation.nameMaxLength": "Die Bezeichnung darf höchstens 255 Zeichen haben.",
  "timeManagement.workSchedules.form.validation.nameRequired": "Bitte eine Bezeichnung eingeben.",
  "timeManagement.workSchedules.form.validation.validFromRequired": "Bitte einen Gültigkeitsbeginn eingeben.",
  "timeManagement.workSchedules.list.cycle": "Turnus über {{weeks}} Woche(n)",
  "timeManagement.workSchedules.list.empty": "Für diese Einheit gibt es noch keine Zeitmodelle.",
  "timeManagement.workSchedules.weekday.1": "Montag",
  "timeManagement.workSchedules.weekday.2": "Dienstag",
  "timeManagement.workSchedules.weekday.3": "Mittwoch",
  "timeManagement.workSchedules.weekday.4": "Donnerstag",
  "timeManagement.workSchedules.weekday.5": "Freitag",
  "timeManagement.workSchedules.weekday.6": "Samstag",
  "timeManagement.workSchedules.weekday.7": "Sonntag",
  "timeTracking.correct": "Korrigieren",
  "timeTracking.corrected": "korrigiert",
  "timeTracking.countingStamps": "{{count}} zählende Buchungen",
  "timeTracking.employment": "Dienstverhältnis",
  "timeTracking.empty": "In diesem Zeitraum wurde nichts erfasst.",
  "timeTracking.errors.actionFailed": "Die Buchung konnte nicht gespeichert werden.",
  "timeTracking.errors.loadFailed": "Die Buchungen konnten nicht geladen werden.",
  "timeTracking.errors.rangeOrder": "Das Ende darf nicht vor dem Beginn liegen.",
  "timeTracking.form.abortCorrection": "Korrektur abbrechen",
  "timeTracking.form.bookingType": "Buchungsart",
  "timeTracking.form.chooseBookingType": "Bitte wählen",
  "timeTracking.form.correcting": "Korrektur der Buchung von {{time}}",
  "timeTracking.form.date": "Datum",
  "timeTracking.form.hint": "Nichts wird überschrieben: Zurückziehen setzt einen Status, Korrigieren schreibt eine neue Buchung mit Verweis auf die alte. Ein abgeschlossener Tag wird abgelehnt.",
  "timeTracking.form.reason": "Begründung",
  "timeTracking.form.record": "Erfassen",
  "timeTracking.form.time": "Uhrzeit",
  "timeTracking.form.title": "Buchung erfassen",
  "timeTracking.from": "Von",
  "timeTracking.isCorrection": "Korrektur",
  "timeTracking.organizationUnit": "Organisationseinheit",
  "timeTracking.showWithdrawn": "Zurückgezogene anzeigen",
  "timeTracking.to": "Bis",
  "timeTracking.withdraw": "Zurückziehen",
  "timeTracking.withdrawn": "zurückgezogen",
  "employmentPicker.placeholder": "Name, Personal- oder Vertragsnummer",
  "employmentPicker.empty": "Kein Dienstverhältnis gefunden",
  "employmentPicker.loading": "Suche …",
  "employmentPicker.more": "Weitere Treffer – bitte genauer suchen",
  "employmentPicker.personnelNumber": "PNR {{number}}",
  "employmentPicker.allUnits": "Alle OEs",
  "employmentPicker.unitPlaceholder": "OE suchen",
  "employmentPicker.noUnit": "Keine OE gefunden",
  "timeTracking.form.noBookingType": "Keine Buchungsart gefunden",
  "nav.secondary.persons.employments": "Dienstverhältnisse",
  "persons.list.tabs.employments": "Dienstverhältnisse",
  "employments.directory.subtitle": "Alle Dienstverhältnisse des Mandanten – nach Name, Personal- oder Vertragsnummer.",
  "employments.directory.back": "Zurück zur Liste",
  "employments.directory.company": "Firma",
  "employments.directory.chooseCompany": "Firma wählen",
  "employments.directory.noCompany": "Dieser Mandant hat keine Firma, an der ein Dienstverhältnis angelegt werden kann.",
  "employments.directory.search": "Suche",
  "employments.directory.empty": "Für diesen Mandanten gibt es noch keine Dienstverhältnisse.",
  "employments.directory.personnelNumber": "Personalnr.",
  "employments.directory.state": "Status",
  "employments.directory.actions": "Aktionen",
  "employments.directory.more": "Weitere laden",
  "employments.state.ACTIVE": "aktiv",
  "employments.state.UPCOMING": "künftig",
  "employments.state.ENDED": "beendet",
  "employments.person.none": "Diese Person hat kein Dienstverhältnis, das Sie sehen dürfen.",
  "employments.person.open": "Öffnen",
  "employments.person.tracking": "Zeiterfassung",
  "employments.person.account": "Zeitkonto",
  "persons.list.search": "Suche",
  "persons.list.searchPlaceholder": "Name, Namensteil oder Personalnummer",
  "persons.list.columns.personnelNumber": "Personalnr.",
  "processing.closing.incomplete": "Nicht vollständig verarbeitet: {{count}} Lücke(n) – der Abschluss bleibt gesperrt.",
  "processing.closing.moreGaps": "… und {{count}} weitere",
  "processing.closing.gap.NEVER_COMPUTED": "noch nie verarbeitet",
  "processing.closing.gap.FAILED": "Fehler bei der Verarbeitung",
  "processing.closing.gap.DEPENDENT": "übersprungen, weil ein Vortag fehlschlug",
  "processing.closing.gap.RUN_FAILED": "der Lauf schlug als Ganzes fehl",
  "processing.closing.gap.NO_RULE_SET": "kein Regelwerk zugeordnet",
  "processing.closing.gap.NO_WORK_SCHEDULE": "kein Zeitmodell",
  "processing.closing.gap.INPUT_CHANGED": "Stempel nach der Verarbeitung geändert"
}
